import React, { useState, useEffect, useRef } from 'react';

import WriteToUs from "../Components/WriteToUs";
import { Link } from "react-router-dom";
import HelmetSco from './HelmetSco';
const useDocumentHead = ({ title, description, author, ogTitle, ogDescription, ogImage }) => {
  useEffect(() => {
      // Set title
      document.title = title;

      // Set meta tags
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
          metaDescription.content = description;
      } else {
          const newMetaDescription = document.createElement('meta');
          newMetaDescription.name = 'description';
          newMetaDescription.content = description;
          document.head.appendChild(newMetaDescription);
      }

      const metaAuthor = document.querySelector('meta[name="author"]');
      if (metaAuthor) {
          metaAuthor.content = author;
      } else {
          const newMetaAuthor = document.createElement('meta');
          newMetaAuthor.name = 'author';
          newMetaAuthor.content = author;
          document.head.appendChild(newMetaAuthor);
      }

      const metaOgTitle = document.querySelector('meta[property="og:title"]');
      if (metaOgTitle) {
          metaOgTitle.content = ogTitle;
      } else {
          const newMetaOgTitle = document.createElement('meta');
          newMetaOgTitle.property = 'og:title';
          newMetaOgTitle.content = ogTitle;
          document.head.appendChild(newMetaOgTitle);
      }

      const metaOgDescription = document.querySelector('meta[property="og:description"]');
      if (metaOgDescription) {
          metaOgDescription.content = ogDescription;
      } else {
          const newMetaOgDescription = document.createElement('meta');
          newMetaOgDescription.property = 'og:description';
          newMetaOgDescription.content = ogDescription;
          document.head.appendChild(newMetaOgDescription);
      }

      const metaOgImage = document.querySelector('meta[property="og:image"]');
      if (metaOgImage) {
          metaOgImage.content = ogImage;
      } else {
          const newMetaOgImage = document.createElement('meta');
          newMetaOgImage.property = 'og:image';
          newMetaOgImage.content = ogImage;
          document.head.appendChild(newMetaOgImage);
      }

      // Cleanup function to remove meta tags if needed
      return () => {
          // Optionally remove the meta tags on component unmount
          // This can be customized based on your needs
      };
  }, [title, description, author, ogTitle, ogDescription, ogImage]);
};

// import CountUp from "react-countup";
// import Swiper from "swiper";
// import 'swiper/css/swiper.min.css';
// import "./../../node_modules/swiper/swiper-bundle";
const CountUp = ({ end, duration, isPercentage }) => {
  const [count, setCount] = useState(0);
  const start = useRef(0);
  const startTime = useRef(null);
  useEffect(() => {
    startTime.current = null;
    start.current = count;
    const increment = end - start.current;
    const step = (timestamp) => {
      if (!startTime.current) startTime.current = timestamp;
      const elapsed = timestamp - startTime.current;
      const progress = Math.min(elapsed / duration, 1);
      setCount(start.current + increment * progress);
      if (elapsed < duration) {
        requestAnimationFrame(step);
      }
    };
    requestAnimationFrame(step);
  }, [end, duration]);

  return (
    <span>
      {isPercentage ? `${Math.round(count)}%` : `${count.toFixed(0).padStart(2, '0')}`}
    </span>
  );
};

const Home = () => {
  const [bgImage, setBgImage] = useState(null);
  // const pageTitle = "Mumtalikati.com: Oman Property Real Estate | Sell | Buy | Rent";
  // const pageDescription = "Mumtalikati offers the best residential and commercial properties for buy, rent, or sale in Oman. From apartments and villas to offices and shops, find the perfect property with ease.";
  // const author = "Mumtalikati";
  // const ogImage = "https://resx.mumtalikati.com/img/mumtalikati-logo.png";

  // useDocumentHead({ title: pageTitle, description: pageDescription, author, ogTitle: pageTitle, ogDescription: pageDescription, ogImage });

  useEffect(() => {
      const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
              if (entry.isIntersecting) {
                  // Set the background image when the section is in view
                  setBgImage('/images/agile-white-logo.svg');
                  observer.unobserve(entry.target); // Stop observing after loading
              }
          });
      });

      const section = document.querySelector('.expertise-module--expertise--c84b2');
      if (section) {
          observer.observe(section);
      }

      return () => {
          if (section) {
              observer.unobserve(section);
          }
      };
  }, []);
  // useEffect(() => {
  //   const swiperContainer = document.querySelector(".swiper"); // Get the swiper container
  //   if (!swiperContainer) {
  //     console.error("Swiper container not found");
  //     return; // Exit early if swiper container is not found
  //   }

  //   const mySwiper = new Swiper(swiperContainer, {
  //     slidesPerView: 3,
  //     spaceBetween: 30,
  //   });

  //   return () => mySwiper.destroy();
  // }, []);
  const backgroundUrl =
    "https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/03/Home-Page.webp";
    const localBusinessJsonLd = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Alphai Solutions",
      "description": "Alphai Solutions is a tech company offering IT consulting, software development, and digital transformation services in Pakistan.",
      "url": "https://www.alphaisolutions.com/",
      "image": "https://www.alphaisolutions.com/logo.png",
      "logo": "https://www.alphaisolutions.com/logo.png",
      "telephone": "+92 333 5489960",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Block A Plaza# 1, Next to Askari Bank, Valencia Town, Commercial Market",
        "addressLocality": "Lahore",
        "addressRegion": "Punjab",
        "postalCode": "54000",
        "addressCountry": "PK"
      },
      "openingHours": [
        "Mo-Fr 09:00-18:00"
      ],
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "31.3949",
        "longitude": "74.2352"
      },
      "sameAs": [
        "https://www.facebook.com/alphaisolutions",
        "https://www.linkedin.com/company/alphai-solutions",
        "https://www.instagram.com/alphaisolutions"
      ],
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Ali Raza"
          },
          "datePublished": "2024-11-10",
          "reviewBody": "Excellent service and professional team. Highly recommended for software development projects.",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "bestRating": "5"
          }
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Sarah Khan"
          },
          "datePublished": "2025-01-15",
          "reviewBody": "Great experience working with Alphai Solutions on our e-commerce platform. Delivered on time!",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "4.8",
            "bestRating": "5"
          }
        }
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "57"
      },
      "priceRange": "$$",
      "founder": {
        "@type": "Person",
        "name": "Your Name Here"
      },
      "foundingDate": "2020-01-10",
      "employee": {
        "@type": "OrganizationRole",
        "roleName": "Software Developer"
      },
      "areaServed": {
        "@type": "Country",
        "name": "Pakistan"
      },
      "makesOffer": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "IT Consulting",
            "description": "Expert advice for digital transformation and technology planning."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Web & App Development",
            "description": "Custom websites and mobile apps built for performance and scalability."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "UI/UX Design",
            "description": "Creating engaging and intuitive user experiences across platforms."
          }
        }
      ]
    };
    
    const webPageJsonLd = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Alphai Solutions | Leading IT Services and IT solutions company",
      "description": "Alphai specializes in IT services, offering expert consulting, managed IT support, and advanced cloud computing for business growth",
      "url": window.location.href,
      "primaryImageOfPage": {
        "@type": "ImageObject",
        "url": backgroundUrl
      },
      "about": localBusinessJsonLd
    };

  return (
    <>
   <HelmetSco 
      title={"Alphai Solutions | Leading IT Services and IT solutions company"} 
      description={"Alphai specializes in IT services, offering expert consulting, managed IT support, and advanced cloud computing for business growth"} 
      imag={backgroundUrl} 
      jsonLd={webPageJsonLd} 
    />
    <script type="application/ld+json">
      {JSON.stringify(localBusinessJsonLd)}
    </script>
      <section
        className="mainBanner-module--main_banner--b7162"
        style={{ backgroundImage: `url(${backgroundUrl})` }}
      >
        <div className="container">
          <div className="mainBanner-module--banner_wrap--7f8d1">
            <div className="mainBanner-module--banner_info--c335d">
              <h1
                className="mainBanner-module--ptSans--746de"
                // data-aos="fade-up"
                // data-aos-delay="50"
              >
                Tailored Tech Solutions
                <br /> <span>Infused with AI </span>
                <br />
                Alpha Innovative Solutions, <br />
                Your Gateway to Innovation!
              </h1>
              {/* <Link
                target="_self"
                className="linkButtonRed-module--btn_red--0ea81 undefined"
                to={"/contactus"}
              >
                Get Started
              </Link> */}
            </div>
          </div>
        </div>
      </section>
      <section className="counter-module--counter--d12f6">
        <div className="container">
          <div className="counter-module--counter_wrapper--bf60a">
          <ul className="counter-module--counter_listing--5a586">
      <li data-aos="fade-up" data-aos-delay="50">
        <strong>
          <CountUp end={10} duration={2000} />
        </strong>
        <p>Targeted Industries</p>
      </li>
      <li data-aos="fade-up" data-aos-delay="50">
        <strong>
          <CountUp end={8} duration={2000} />
        </strong>
        <p>White-Label Solutions</p>
      </li>
      <li data-aos="fade-up" data-aos-delay="50">
        <strong>
          <CountUp end={49} duration={2000} />
        </strong>
        <p>Tech team</p>
      </li>
      <li data-aos="fade-up" data-aos-delay="50">
        <strong>
          <CountUp end={100} duration={2000} isPercentage />
        </strong>
        <p>Scaleability</p>
      </li>
    </ul>
          </div>
        </div>
      </section>
      <section className="whoWeServe-module--who_we_serve--6c78e undefined">
        <div className="container">
          <div className="whoWeServe-module--serve_wrap--a73a8">
            <div className="whoWeServe-module--mix_heading--74e60">
              <span data-aos="fade-up" data-aos-delay="50">
                Who We Serve
              </span>
              <h2
                className="whoWeServe-module--ptSans--2c315"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                We partner with Enterprises,
                <span className="text-change">SME</span>s, and Startup and
                provide digital solutions and technology experts for their
                <Link to="/services/devops">
                  {" "}
                  software
                </Link>
                , <Link to="/services/product-engineering/product-development">product</Link>, and
                <Link to="/services/mobile-app-development/">
                  {" "}
                  application development
                </Link>
                .
              </h2>
            </div>
            <ul className="whoWeServe-module--serve_listing--69c4b">
              <li data-aos="fade-up" data-aos-delay="200">
                <div className="whoWeServe-module--serve_col--9ab30">
                  <i>
                    <svg
                      width="52"
                      height="52"
                      viewBox="0 0 52 52"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M25.5709 0.928251C25.5709 0.41577 25.9867 0 26.4992 0C27.0117 0 27.4274 0.41577 27.4274 0.928251V6.13773C27.4274 6.65021 27.0117 7.06598 26.4992 7.06598C25.9867 7.06598 25.5709 6.65021 25.5709 6.13773V0.928251ZM21.7154 22.2169C21.3571 21.8529 21.3623 21.2657 21.7262 20.9074C22.0902 20.549 22.6774 20.5542 23.0357 20.9182L26.4997 24.433L29.9636 20.9182C30.3219 20.5542 30.9087 20.549 31.2731 20.9074C31.6371 21.2657 31.6422 21.8525 31.2839 22.2169L27.4284 26.1293V33.8338C27.4284 34.3463 27.0126 34.7621 26.5001 34.7621C25.9876 34.7621 25.5719 34.3463 25.5719 33.8338V26.1293L21.7164 22.2169H21.7154ZM22.7508 40.9258C22.7508 41.4383 22.335 41.8541 21.8225 41.8541C21.31 41.8541 20.8943 41.4383 20.8943 40.9258V38.2079C20.8943 37.2482 20.6853 36.3584 20.2855 35.5739C19.8848 34.7885 19.2869 34.0973 18.5119 33.5352C16.7779 32.2784 15.3485 30.6144 14.3632 28.6854C13.4121 26.8284 12.8763 24.7254 12.8763 22.4997C12.8763 18.7427 14.4021 15.337 16.8669 12.8705L16.8729 12.8644C19.3395 10.4009 22.7438 8.87596 26.5001 8.87596C30.2571 8.87596 33.6628 10.4018 36.1293 12.8665L36.1353 12.8726C38.5989 15.3391 40.1238 18.7435 40.1238 22.4997C40.1238 24.7193 39.5863 26.8223 38.6378 28.6824C37.6573 30.611 36.227 32.2741 34.4883 33.5343C33.7124 34.0964 33.1153 34.7881 32.7155 35.5725C32.3157 36.357 32.1068 37.2472 32.1068 38.2079V42.0146C32.1068 42.5759 31.8758 43.0871 31.5075 43.4571C31.134 43.8293 30.6228 44.0603 30.0616 44.0603H22.9403C22.8885 44.0603 22.8393 44.0814 22.8065 44.1142C22.7737 44.1501 22.7516 44.1975 22.7516 44.2481V44.7424C22.7516 44.7929 22.7737 44.8404 22.8078 44.8745L22.8255 44.8927C22.8579 44.916 22.898 44.9298 22.9403 44.9298H29.4628C30.0258 44.9298 30.5387 45.1608 30.9073 45.5291L30.9708 45.5999C31.3032 45.9647 31.5066 46.4478 31.5066 46.9749V47.4697C31.5066 48.0318 31.2765 48.5443 30.9065 48.9143C30.5365 49.2843 30.0248 49.5144 29.4628 49.5144H23.6225C23.11 49.5144 22.6943 49.0987 22.6943 48.5862C22.6943 48.0737 23.11 47.6579 23.6225 47.6579H29.4628C29.5124 47.6579 29.5595 47.6359 29.5936 47.6018C29.6281 47.5673 29.6497 47.5198 29.6497 47.4701V46.9753C29.6497 46.9322 29.6359 46.892 29.6126 46.8596L29.5945 46.8419C29.5608 46.8082 29.5133 46.7862 29.4628 46.7862H22.9403C22.4123 46.7862 21.9292 46.5816 21.5661 46.2504L21.4952 46.187C21.1252 45.8169 20.8951 45.3045 20.8951 44.7415V44.2471C20.8951 43.6841 21.1252 43.1716 21.4952 42.8017C21.8687 42.4334 22.3799 42.2024 22.9407 42.2024H30.062C30.1147 42.2024 30.1634 42.1812 30.1967 42.1484C30.2295 42.1156 30.2507 42.0664 30.2507 42.0137V38.207C30.2507 36.952 30.5291 35.7777 31.0628 34.7311C31.5956 33.6858 32.3839 32.7697 33.4015 32.0322C34.9032 30.9438 36.1393 29.5065 36.988 27.8426C37.8066 26.246 38.2682 24.4292 38.2682 22.4993C38.2682 19.2482 36.9513 16.305 34.825 14.1791C32.6956 12.0489 29.7524 10.732 26.5013 10.732C23.2503 10.732 20.3071 12.0488 18.1812 14.1751C16.051 16.3045 14.7341 19.2478 14.7341 22.4988C14.7341 24.4235 15.1969 26.2412 16.0142 27.8434C16.86 29.5056 18.0961 30.9415 19.6007 32.0321C20.6174 32.7695 21.4062 33.6848 21.9399 34.7319C22.4735 35.7789 22.752 36.9528 22.752 38.2066V40.9245L22.7508 40.9258ZM44.718 10.9122C45.1601 10.6561 45.7274 10.8068 45.9834 11.2494C46.2395 11.6915 46.0888 12.2588 45.6463 12.5148L41.1362 15.1187C40.6941 15.3747 40.1268 15.224 39.8708 14.7815C39.6147 14.3394 39.7654 13.7721 40.208 13.5161L44.718 10.9122ZM11.8638 29.8808C12.3059 29.6248 12.8733 29.7755 13.1293 30.218C13.3853 30.6601 13.2346 31.2275 12.7921 31.4835L8.282 34.0874C7.83989 34.3434 7.27257 34.1927 7.01657 33.7502C6.76055 33.3081 6.91123 32.7407 7.35377 32.4847L11.8638 29.8808ZM36.4849 3.35653C36.7387 2.91442 37.3043 2.76202 37.7469 3.01589C38.189 3.26976 38.3414 3.83535 38.0875 4.27789L35.484 8.78795C35.2302 9.23006 34.6646 9.38246 34.222 9.12859C33.7799 8.87472 33.6275 8.30913 33.8814 7.86659L36.4849 3.35653ZM17.5162 36.2107C17.7701 35.7686 18.3356 35.6162 18.7782 35.8701C19.2203 36.124 19.3727 36.6895 19.1188 37.1321L16.5154 41.6421C16.2615 42.0842 15.6959 42.2367 15.2534 41.9828C14.8113 41.7289 14.6588 41.1633 14.9127 40.7208L17.5162 36.2107ZM4.92825 23.4272C4.41577 23.4272 4 23.0114 4 22.4989C4 21.9864 4.41577 21.5707 4.92825 21.5707H10.1377C10.6502 21.5707 11.066 21.9864 11.066 22.4989C11.066 23.0114 10.6502 23.4272 10.1377 23.4272H4.92825ZM42.8623 23.4272C42.3498 23.4272 41.934 23.0114 41.934 22.4989C41.934 21.9864 42.3498 21.5707 42.8623 21.5707H48.0717C48.5842 21.5707 49 21.9864 49 22.4989C49 23.0114 48.5842 23.4272 48.0717 23.4272H42.8623ZM7.35432 12.5135C6.91221 12.2575 6.76153 11.6901 7.01712 11.2481C7.27315 10.806 7.84046 10.6553 8.28255 10.9109L12.7917 13.5148C13.2338 13.7708 13.3845 14.3381 13.1289 14.7802C12.8729 15.2223 12.3056 15.373 11.8635 15.1174L7.35432 12.5135ZM40.2074 31.4822C39.7653 31.2261 39.6146 30.6588 39.8702 30.2167C40.1262 29.7746 40.6935 29.6239 41.1356 29.8795L45.6448 32.4834C46.0869 32.7395 46.2376 33.3068 45.982 33.7489C45.726 34.191 45.1587 34.3417 44.7166 34.0861L40.2074 31.4822ZM14.9122 4.277C14.6583 3.83489 14.8107 3.26887 15.2528 3.015C15.6949 2.76113 16.2609 2.91354 16.5148 3.35565L19.1183 7.86571C19.3721 8.30782 19.2197 8.87384 18.7776 9.12771C18.3355 9.38158 17.7695 9.22917 17.5156 8.78706L14.9122 4.277ZM33.8808 37.1312C33.627 36.6891 33.7794 36.1231 34.2215 35.8692C34.6636 35.6153 35.2296 35.7677 35.4835 36.2098L38.0869 40.7199C38.3408 41.162 38.1884 41.728 37.7463 41.9819C37.3042 42.2358 36.7382 42.0834 36.4843 41.6413L33.8808 37.1312Z"
                        fill="black"
                      ></path>
                    </svg>
                  </i>
                  <h3 className="whoWeServe-module--ptSans--2c315">Startup</h3>
                  <p>
                    Helping rising businesses to create MVPs or envisioned
                    products
                  </p>
                  <a
                    className="whoWeServe-module--btn_more--05a34"
                    href="/who-we-serve/startups"
                  >
                    More
                    <i className="whoWeServe-module--cardLink--161c7">
                      <svg
                        width="25"
                        height="12"
                        viewBox="0 0 25 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M24.5492 5.33639C24.549 5.33611 24.5487 5.33578 24.5484 5.3355L19.6498 0.460497C19.2828 0.0952938 18.6892 0.0966529 18.3239 0.463684C17.9587 0.830668 17.9601 1.42425 18.3271 1.7895L21.616 5.0625H1.76172C1.24394 5.0625 0.824219 5.48221 0.824219 6C0.824219 6.51778 1.24394 6.9375 1.76172 6.9375H21.616L18.3271 10.2105C17.9601 10.5757 17.9587 11.1693 18.324 11.5363C18.6893 11.9034 19.2829 11.9047 19.6498 11.5395L24.5485 6.6645C24.5487 6.66421 24.549 6.66389 24.5493 6.66361C24.9165 6.29714 24.9153 5.70164 24.5492 5.33639Z"
                          fill="black"
                        ></path>
                      </svg>
                    </i>
                  </a>
                </div>
              </li>
              <li data-aos="fade-up" data-aos-delay="200">
                <div className="whoWeServe-module--serve_col--9ab30">
                  <i>
                    <svg
                      width="52"
                      height="52"
                      viewBox="0 0 52 52"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.28546 2C6.92615 2 5 3.92615 5 6.28546V37.1407C5 39.5 6.92615 41.4262 9.28546 41.4262H24.7131V48.2829H21.2847C20.1246 48.2669 20.1246 50.0143 21.2847 49.9971C24.1587 50.0036 26.9859 49.9971 29.8557 49.9971C31.0158 50.0132 31.0158 48.2657 29.8557 48.2829H26.4269V41.4262H41.8545C44.2138 41.4262 46.14 39.5 46.14 37.1407L46.1404 6.28546C46.1404 3.92615 44.2142 2 41.8549 2H9.28546ZM9.28546 3.71418H41.8549C43.2944 3.71418 44.4262 4.84603 44.4262 6.28546V37.1407C44.4262 38.5802 43.2944 39.712 41.8549 39.712H25.7024C25.6546 39.7024 25.6056 39.699 25.5566 39.699C25.5153 39.7002 25.4736 39.7055 25.4331 39.712H9.28546C7.84603 39.712 6.71418 38.5802 6.71418 37.1407L6.7138 6.28546C6.7138 4.84603 7.84565 3.71418 9.28507 3.71418H9.28546ZM36.9573 17.3503C36.9347 17.3514 36.9114 17.3533 36.8888 17.3568H32.4208C31.2622 17.3407 31.2622 19.087 32.4208 19.0709H34.2337L26.8899 24.1332L19.7772 18.1905C19.408 17.8829 18.8581 17.9388 18.5586 18.3141L13.4795 24.6719C12.7667 25.5657 14.1074 26.6356 14.8203 25.7417L19.3518 20.0685L26.2904 25.8657C26.5862 26.1122 27.0098 26.1317 27.3266 25.9128L36.1321 19.8447V21.7112C36.116 22.8702 37.8627 22.8702 37.8463 21.7112V18.3246C37.9201 17.7931 37.4931 17.3251 36.9574 17.3504L36.9573 17.3503Z"
                        fill="#201D1D"
                      ></path>
                    </svg>
                  </i>
                  <h3 className="whoWeServe-module--ptSans--2c315">Scaleup</h3>
                  <p>
                    Curated services for scaling-up issues with business accord
                  </p>
                  <a
                    className="whoWeServe-module--btn_more--05a34"
                    href="/who-we-serve/scale-ups"
                  >
                    More
                    <i className="whoWeServe-module--cardLink--161c7">
                      <svg
                        width="25"
                        height="12"
                        viewBox="0 0 25 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M24.5492 5.33639C24.549 5.33611 24.5487 5.33578 24.5484 5.3355L19.6498 0.460497C19.2828 0.0952938 18.6892 0.0966529 18.3239 0.463684C17.9587 0.830668 17.9601 1.42425 18.3271 1.7895L21.616 5.0625H1.76172C1.24394 5.0625 0.824219 5.48221 0.824219 6C0.824219 6.51778 1.24394 6.9375 1.76172 6.9375H21.616L18.3271 10.2105C17.9601 10.5757 17.9587 11.1693 18.324 11.5363C18.6893 11.9034 19.2829 11.9047 19.6498 11.5395L24.5485 6.6645C24.5487 6.66421 24.549 6.66389 24.5493 6.66361C24.9165 6.29714 24.9153 5.70164 24.5492 5.33639Z"
                          fill="black"
                        ></path>
                      </svg>
                    </i>
                  </a>
                </div>
              </li>
              <li data-aos="fade-up" data-aos-delay="200">
                <div className="whoWeServe-module--serve_col--9ab30">
                  <i>
                    <svg
                      width="52"
                      height="52"
                      viewBox="0 0 52 52"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2 48.9983V39.505L7.43366 37.4092V48.9983"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M7.43274 37.4113V30.0372L14.0308 27.6309C14.0308 27.6309 14.0308 42.9982 14.0308 49.0004"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M14.0319 27.6304L18.5341 28.5619V48.9999"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M18.5337 28.5609V12.4928L24.1224 9L32.9715 12.3378V48.9992"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M32.9725 27.7063L43.4517 30.0352V48.9983"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M43.4506 37.4092L49.0397 39.505V48.9983"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M23.1129 9.62012V26.775L27.3047 24.5241V48.9985"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </i>
                  <h3 className="whoWeServe-module--ptSans--2c315">
                    Enterprise
                  </h3>
                  <p>
                    Skilled &amp; qualified experts to enhance business
                    processes
                  </p>
                  <a
                    className="whoWeServe-module--btn_more--05a34"
                    href="/who-we-serve/enterprises/"
                  >
                    More
                    <i className="whoWeServe-module--cardLink--161c7">
                      <svg
                        width="25"
                        height="12"
                        viewBox="0 0 25 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M24.5492 5.33639C24.549 5.33611 24.5487 5.33578 24.5484 5.3355L19.6498 0.460497C19.2828 0.0952938 18.6892 0.0966529 18.3239 0.463684C17.9587 0.830668 17.9601 1.42425 18.3271 1.7895L21.616 5.0625H1.76172C1.24394 5.0625 0.824219 5.48221 0.824219 6C0.824219 6.51778 1.24394 6.9375 1.76172 6.9375H21.616L18.3271 10.2105C17.9601 10.5757 17.9587 11.1693 18.324 11.5363C18.6893 11.9034 19.2829 11.9047 19.6498 11.5395L24.5485 6.6645C24.5487 6.66421 24.549 6.66389 24.5493 6.66361C24.9165 6.29714 24.9153 5.70164 24.5492 5.33639Z"
                          fill="black"
                        ></path>
                      </svg>
                    </i>
                  </a>
                </div>
              </li>
              <li data-aos="fade-up" data-aos-delay="200">
                <div className="whoWeServe-module--serve_col--9ab30">
                  <i>
                    <svg
                      width="52"
                      height="49"
                      viewBox="0 0 52 49"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M48.5938 38.3953H47.0938V22.5233C47.094 21.9325 46.91 21.3544 46.564 20.8591C46.2181 20.3637 45.725 19.9724 45.1447 19.7326L38.6562 17.0509V10.0523C38.6563 9.2428 38.3105 8.46643 37.6952 7.89401C37.0798 7.32158 36.2452 7 35.375 7H16.625C15.7548 7 14.9202 7.32158 14.3048 7.89401C13.6895 8.46643 13.3438 9.2428 13.3438 10.0523V17.0509L6.85531 19.7326C6.27498 19.9724 5.78193 20.3637 5.43596 20.8591C5.09 21.3544 4.90599 21.9325 4.90625 22.5233V38.3953H3.40625C3.03329 38.3953 2.6756 38.5332 2.41188 38.7785C2.14816 39.0238 2 39.3565 2 39.7035C2 40.0504 2.14816 40.3832 2.41188 40.6285C2.6756 40.8738 3.03329 41.0116 3.40625 41.0116H48.5938C48.9667 41.0116 49.3244 40.8738 49.5881 40.6285C49.8518 40.3832 50 40.0504 50 39.7035C50 39.3565 49.8518 39.0238 49.5881 38.7785C49.3244 38.5332 48.9667 38.3953 48.5938 38.3953ZM13.3438 38.3953H7.71875V22.5233C7.71898 22.4386 7.7457 22.3558 7.79564 22.2851C7.84558 22.2143 7.91659 22.1586 8 22.1247L13.3438 19.914V38.3953ZM28.3438 38.3953H23.6562V34.4709C23.6562 33.8927 23.9032 33.3381 24.3427 32.9293C24.7823 32.5204 25.3784 32.2907 26 32.2907C26.6216 32.2907 27.2177 32.5204 27.6573 32.9293C28.0968 33.3381 28.3437 33.8927 28.3438 34.4709V38.3953ZM35.8438 38.3953H31.1562V34.4709C31.1562 33.1988 30.613 31.9788 29.646 31.0793C28.679 30.1798 27.3675 29.6744 26 29.6744C24.6325 29.6744 23.321 30.1798 22.354 31.0793C21.387 31.9788 20.8438 33.1988 20.8438 34.4709V38.3953H16.1562V10.0523C16.1562 9.93668 16.2056 9.82577 16.2935 9.74399C16.3815 9.66222 16.5007 9.61628 16.625 9.61628H35.375C35.4993 9.61628 35.6185 9.66222 35.7065 9.74399C35.7944 9.82577 35.8438 9.93668 35.8438 10.0523V38.3953ZM44.2812 38.3953H38.6562V19.914L44 22.1247C44.0834 22.1586 44.1544 22.2143 44.2044 22.2851C44.2543 22.3558 44.281 22.4386 44.2812 22.5233V38.3953Z"
                        fill="#323232"
                        stroke="white"
                      ></path>
                      <path
                        d="M22.56 14.5956C22.1712 14.2266 21.5413 14.2266 21.1525 14.5956L18.1666 17.4299C17.7778 17.799 17.7778 18.3968 18.1666 18.7659L21.1525 21.6002C21.3469 21.7847 21.6016 21.877 21.8563 21.877C22.1109 21.877 22.3656 21.7847 22.56 21.6002C22.9488 21.2311 22.9488 20.6333 22.56 20.2642L20.2777 18.0979L22.56 15.9316C22.9488 15.5625 22.9488 14.9647 22.56 14.5956V14.5956Z"
                        fill="#323232"
                        stroke="white"
                        strokeWidth="0.6"
                      ></path>
                      <path
                        d="M30.8477 14.5959C30.4589 14.2268 29.8291 14.2268 29.4403 14.5959C29.0515 14.9649 29.0515 15.5628 29.4403 15.9318L31.7225 18.0982L29.4403 20.2645C29.0515 20.6335 29.0515 21.2314 29.4403 21.6004C29.6347 21.785 29.8893 21.8772 30.144 21.8772C30.3987 21.8772 30.6533 21.785 30.8477 21.6004L33.8336 18.7661C34.2224 18.3971 34.2224 17.7992 33.8336 17.4302L30.8477 14.5959Z"
                        fill="#323232"
                        stroke="white"
                        strokeWidth="0.6"
                      ></path>
                      <path
                        d="M27.3367 14.3685C26.8037 14.2011 26.2296 14.4713 26.0521 14.9658L24.0212 20.6331C23.8437 21.128 24.1313 21.663 24.6633 21.8281C24.7699 21.8613 24.8785 21.877 24.9846 21.877C25.41 21.877 25.8061 21.6265 25.9479 21.2308L27.9788 15.5635C28.1563 15.0686 27.8687 14.5336 27.3367 14.3685V14.3685Z"
                        fill="#323232"
                        stroke="white"
                        strokeWidth="0.6"
                      ></path>
                    </svg>
                  </i>
                  <h3 className="whoWeServe-module--ptSans--2c315">NGOs</h3>
                  <p>
                  Dedicated resources to strengthen nonprofit operations and outreach
                  </p>
                  <a
                    className="whoWeServe-module--btn_more--05a34"
                    href="/who-we-serve/it-firms/"
                  >
                    More
                    <i className="whoWeServe-module--cardLink--161c7">
                      <svg
                        width="25"
                        height="12"
                        viewBox="0 0 25 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M24.5492 5.33639C24.549 5.33611 24.5487 5.33578 24.5484 5.3355L19.6498 0.460497C19.2828 0.0952938 18.6892 0.0966529 18.3239 0.463684C17.9587 0.830668 17.9601 1.42425 18.3271 1.7895L21.616 5.0625H1.76172C1.24394 5.0625 0.824219 5.48221 0.824219 6C0.824219 6.51778 1.24394 6.9375 1.76172 6.9375H21.616L18.3271 10.2105C17.9601 10.5757 17.9587 11.1693 18.324 11.5363C18.6893 11.9034 19.2829 11.9047 19.6498 11.5395L24.5485 6.6645C24.5487 6.66421 24.549 6.66389 24.5493 6.66361C24.9165 6.29714 24.9153 5.70164 24.5492 5.33639Z"
                          fill="black"
                        ></path>
                      </svg>
                    </i>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="whatWeDo-module--what_we_do--b317a">
        <div className="container">
          <div className="whatWeDo-module--what_we_do_wrap--06a4d">
            <div className="whatWeDo-module--mix_heading--f834d">
              <span data-aos="fade-up" data-aos-delay="50">
                Services
              </span>
              <h2
                className="whatWeDo-module--ptSans--a1402"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                What we do
              </h2>
              <p data-aos="fade-up" data-aos-delay="150">
                Bespoke solutions for business needs with endwise management
                &amp; support
              </p>
            </div>
            <div className="whatWeDo-module--we_do_list_wrap--15a73">
              <ul className="whatWeDo-module--we_do_listing--6d612">
                <li data-aos="fade-up" data-aos-delay="200">
                  <Link to="/services/product-engineering/">
                    <div className="whatWeDo-module--box_blur_content--f1fba">
                      <div className="whatWeDo-module--we_do_box--fd6fe">
                        <picture>
                          <source
                            srcSet="
                                https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/01/we-do-product.webp
                              "
                            media="(min-width: 150px)"
                            type="image/webp"
                          />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/01/we-do-product.jpg"
                            alt="we-do-img"
                            loading="lazy"
                            width="100%"
                            height="100%"
                          />
                        </picture>
                      </div>
                      <div className="whatWeDo-module--we_do_box_hover--948a9">
                        <h4>Product Engineering</h4>
                        <p>
                          Alphai solution focuses on providing end-to-end
                          software product development, management, &amp;
                          modernization
                        </p>
                        <ul>
                          <li>Discovery Sprint</li>
                          <li>UX/UI Design</li>
                          <li>Product Development</li>
                          <li>Product Management</li>
                        </ul>
                      </div>
                    </div>
                  </Link>
                </li>
                <li data-aos="fade-up" data-aos-delay="200">
                  <Link to="/talent-solution/">
                    <div className="whatWeDo-module--box_blur_content--f1fba">
                      <div className="whatWeDo-module--we_do_box--fd6fe">
                        <picture>
                          <source
                            srcSet="
                                https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/01/we-do-talent.webp
                              "
                            media="(min-width: 150px)"
                            type="image/webp"
                          />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/01/we-do-talent.png"
                            alt="we-do-img"
                            loading="lazy"
                            width="100%"
                            height="100%"
                          />
                        </picture>
                      </div>
                      <div className="whatWeDo-module--we_do_box_hover--948a9">
                        <h4>Talent Solution</h4>
                        <p>
                          Alphai Solution provides talent solutions tailored to
                          <br />
                          your business needs, approach, and
                          <br />
                          requirements.
                        </p>
                        <ul>
                          <li>Build Your Team</li>
                          <li>Hire Developer</li>
                          <li>ODC</li>
                        </ul>
                      </div>
                    </div>
                  </Link>
                </li>
                <li data-aos="fade-up" data-aos-delay="200">
                  <div className="whatWeDo-module--normal_box_listing--44d42">
                    <div className="whatWeDo-module--normal_box_wrap--ff1dd">
                      <Link to="/services/website-development/">
                        <picture className="whatWeDo-module--normal_box--d6ab8">
                          <source
                            srcSet="
                                https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/01/we-do-web.webp
                              "
                            media="(min-width: 150px)"
                            type="image/webp"
                          />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/01/we-do-web.jpg"
                            alt="we-do-img"
                            loading="lazy"
                            width="100%"
                            height="100%"
                          />
                          <h4>Web Development</h4>
                        </picture>
                      </Link>
                    </div>
                    <div className="whatWeDo-module--normal_box_wrap--ff1dd">
                      <Link to="/services/quality-assurance-management/">
                        <picture className="whatWeDo-module--normal_box--d6ab8">
                          <source
                            srcSet="
                                https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/01/we-do-qa.webp
                              "
                            media="(min-width: 150px)"
                            type="image/webp"
                          />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/01/we-do-qa.png"
                            alt="we-do-img"
                            loading="lazy"
                            width="100%"
                            height="100%"
                          />
                          <h4>QA &amp; Support</h4>
                        </picture>
                      </Link>
                    </div>
                    <div className="whatWeDo-module--normal_box_wrap--ff1dd">
                      <Link to="/services/mobile-app-development/">
                        <picture className="whatWeDo-module--normal_box--d6ab8">
                          <source
                            srcSet="
                                https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/01/we-do-mobile.webp
                              "
                            media="(min-width: 150px)"
                            type="image/webp"
                          />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/01/we-do-mobile.png"
                            alt="we-do-img"
                            loading="lazy"
                            width="100%"
                            height="100%"
                          />
                          <h4>Mobile Development</h4>
                        </picture>
                      </Link>
                    </div>
                    <div className="whatWeDo-module--normal_box_wrap--ff1dd">
                      <Link to="/services/devops">
                        <picture className="whatWeDo-module--normal_box--d6ab8">
                          <source
                            srcSet="
                                https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/01/we-do-devops.webp
                              "
                            media="(min-width: 150px)"
                            type="image/webp"
                          />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/01/we-do-devops.png"
                            alt="we-do-img"
                            loading="lazy"
                            width="100%"
                            height="100%"
                          />
                          <h4>DevOps</h4>
                        </picture>
                      </Link>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="caseStudies-module--case_studies--72dc5 undefined">
        {/* <div className="container">
        <div className="caseStudies-module--case_studies_wrap--3d251">
          <div className="caseStudies-module--mix_heading_wrap--3feb0">
            <div className="caseStudies-module--mix_heading--98089">
              <div className="caseStudies-module--viewAllLink--a1065">
                <span data-aos="fade-up" data-aos-delay="50">
                  _Case studies
                </span>
                <a href="/case-studies/">
                  <span className="linkButtonMore-module--btn_more--38bca undefined">
                    View all
                    <i>
                      <svg
                        width="25"
                        height="12"
                        viewBox="0 0 25 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M24.5492 5.33639C24.549 5.33611 24.5487 5.33578 24.5484 5.3355L19.6498 0.460497C19.2828 0.0952938 18.6892 0.0966529 18.3239 0.463684C17.9587 0.830668 17.9601 1.42425 18.3271 1.7895L21.616 5.0625H1.76172C1.24394 5.0625 0.824219 5.48221 0.824219 6C0.824219 6.51778 1.24394 6.9375 1.76172 6.9375H21.616L18.3271 10.2105C17.9601 10.5757 17.9587 11.1693 18.324 11.5363C18.6893 11.9034 19.2829 11.9047 19.6498 11.5395L24.5485 6.6645C24.5487 6.66421 24.549 6.66389 24.5493 6.66361C24.9165 6.29714 24.9153 5.70164 24.5492 5.33639Z"
                          fill="black"
                        ></path>
                      </svg>
                    </i>
                  </span>
                </a>
              </div>
              <h2
                className="caseStudies-module--ptSans--29fa1"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                Our success stories
              </h2>
              <p data-aos="fade-up" data-aos-delay="150">
                We tailor software solutions to address the business challenges
                & needs of our clients.
              </p>
            </div>
          </div>
          <div
            className="swiper-slider case-study-slider"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="swiper">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <div
                    className="caseStudies-module--portfoliolist--f068b"
                    style={{ backgroundColor: '#f5f9ff' }}
                  >
                    <picture>
                      <source
                        srcSet="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/Outer-Banner_Ivira.webp"
                        media="(min-width: 150px)"
                        type="image/webp"
                      />
                      <img
                        src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/Outer-Banner_Ivira.png"
                        alt="Ivira"
                        loading="lazy"
                        width="100%"
                        height="100%"
                      />
                    </picture>
                    <div className="caseStudies-module--descinfo--67198">
                      <div className="caseStudies-module--desc--9ef3b">
                        <h3>Ivira</h3>
                        <h4>
                          <p>Secure & reliable comprehensive healthcare portal.</p>
                        </h4>
                        <p className="location">
                          USA | Healthcare
                        </p>
                      </div>
                      <a
                        className="caseStudies-module--directionBtn--9ec68"
                        href="/case-studies/ivira/"
                      >
                        <button className="caseStudies-module--rightarrow--9c139">
                          <img
                            src="/img/right-go.svg"
                            width="100%"
                            height="100%"
                            alt="right"
                          />
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div> */}
      </section>
      <section
        className="expertise-module--expertise--c84b2"
        style={{
          backgroundImage: bgImage ? `url(${bgImage})` : 'none', 
        }}
      >
        <div className="container">
          <div className="expertise-module--expertise_wrap--1c24e">
            <div className="expertise-module--mix_heading--abe66">
              <span data-aos="fade-up" data-aos-delay="50">
                Domain expertise
              </span>
              <h2
                className="expertise-module--ptSans--64319"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                Industries we are experts in
              </h2>
              <p data-aos="fade-up" data-aos-delay="150">
                Our domain expertise mainly focuses on delivering innovative
                digital solutions, specific to the client’s needs. Embrace the
                future of your product by applying the right technology.
              </p>
            </div>
            <ul
              className="expertise-module--expertise_listing--b3059"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <li>
                <Link to="/industries/banking-finance">
                  <picture>
                    <source
                      srcSet="
                          https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/paper-analysis-1.webp
                        "
                      media="(min-width: 150px)"
                      type="image/webp"
                    />
                    <img
                      src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/paper-analysis-1.png"
                      alt="Banking Finance"
                      loading="lazy"
                      width="100%"
                      height="100%"
                    />
                  </picture>
                  <figcaption>Banking &amp; Finance</figcaption>
                </Link>
              </li>
              <li>
                <Link to="/industries/healthcare">
                  <picture>
                    <source
                      srcSet="
                          https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/team-young-specialist-doctors-standing-corridor-hospital-1.webp
                        "
                      media="(min-width: 150px)"
                      type="image/webp"
                    />
                    <img
                      src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/team-young-specialist-doctors-standing-corridor-hospital-1.png"
                      alt="Healthcare"
                      loading="lazy"
                      width="100%"
                      height="100%"
                    />
                  </picture>
                  <figcaption>Healthcare</figcaption>
                </Link>
              </li>
              <li>
                <Link to="/industries/travel-hospitality">
                  <picture>
                    <source
                      srcSet="
                          https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/people-working-reception-front-view-1.webp
                        "
                      media="(min-width: 150px)"
                      type="image/webp"
                    />
                    <img
                      src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/people-working-reception-front-view-1.png"
                      alt="Travel Hospitality"
                      loading="lazy"
                      width="100%"
                      height="100%"
                    />
                  </picture>
                  <figcaption>Travel &amp; Hospitality</figcaption>
                </Link>
              </li>
              <li>
                <Link to="/industries/supply-chain-logistics">
                  <picture>
                    <source
                      srcSet="
                          https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/pexels-tiger-lily-4481326-1.webp
                        "
                      media="(min-width: 150px)"
                      type="image/webp"
                    />
                    <img
                      src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/pexels-tiger-lily-4481326-1.png"
                      alt="Supply chain Logistics"
                      loading="lazy"
                      width="100%"
                      height="100%"
                    />
                  </picture>
                  <figcaption>Supply chain &amp; Logistics</figcaption>
                </Link>
              </li>
              <li>
                <Link to="/industries/education">
                  <picture>
                    <source
                      srcSet="
                          https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/pexels-max-fischer-5212329-1.webp
                        "
                      media="(min-width: 150px)"
                      type="image/webp"
                    />
                    <img
                      src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/pexels-max-fischer-5212329-1.png"
                      alt="Education"
                      loading="lazy"
                      width="100%"
                      height="100%"
                    />
                  </picture>
                  <figcaption>Education</figcaption>
                </Link>
              </li>
              <li>
                <Link to="/industries/retail-commerce">
                  <picture>
                    <source
                      srcSet="
                          https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/pexels-ksenia-chernaya-3965548-1.webp
                        "
                      media="(min-width: 150px)"
                      type="image/webp"
                    />
                    <img
                      src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/pexels-ksenia-chernaya-3965548-1.png"
                      alt="Retail Commerce"
                      loading="lazy"
                      width="100%"
                      height="100%"
                    />
                  </picture>
                  <figcaption>Retail &amp; Commerce</figcaption>
                </Link>
              </li>
              <li>
                <Link to="industries/social-networking">
                  <picture>
                    <source
                      srcSet="
                          https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/ben-kolde-_zqJaEyo6I4-unsplash-1.webp
                        "
                      media="(min-width: 150px)"
                      type="image/webp"
                    />
                    <img
                      src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/ben-kolde-_zqJaEyo6I4-unsplash-1.png"
                      alt="Social Networking"
                      loading="lazy"
                      width="100%"
                      height="100%"
                    />
                  </picture>
                  <figcaption>Social Networking</figcaption>
                </Link>
              </li>
              <li>
                <Link to="/industries/sports">
                  <picture>
                    <source
                      srcSet="
                          https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/pexels-img-2116469-1.webp
                        "
                      media="(min-width: 150px)"
                      type="image/webp"
                    />
                    <img
                      src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/05/pexels-img-2116469-1.png"
                      alt="Sports"
                      loading="lazy"
                      width="100%"
                      height="100%"
                    />
                  </picture>
                  <figcaption>Sports</figcaption>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="techstacks-module--techstacks--7b836">
        <div className="container">
          <div className="techstacks-module--techstacks_wrap--6c033">
            <div className="techstacks-module--mix_heading--f9645">
              <span data-aos="fade-up" data-aos-delay="50">
                Techstacks
              </span>
              <h2
                className="techstacks-module--ptSans--c1f31"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                30+ looming technologies &amp; stacks
              </h2>
              <p data-aos="fade-up" data-aos-delay="150">
                Get seamless integration with below technology stack and become
                the global leader in digital innovation.
              </p>
            </div>
            <ul
              className="techstacks-module--techstacks_listing--22491"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#EFF8FC"
                      ></rect>
                      <g clipPath="url(#clip0_4061_21597)">
                        <path
                          d="M45.5008 65C34.1402 65 24.9152 55.9456 25.0008 44.5C25.0865 33.0544 33.7133 24 45.5008 24C57.2891 24 66.0008 33.225 66.0008 44.5C66.0008 55.775 56.8615 65 45.5008 65ZM51.5652 61.8393L45.7571 46.2081L40.2902 62.1813C44.3053 63.1214 47.0383 63.3768 51.5652 61.8393ZM37.3865 60.9857L28.674 37.1544C27.4777 39.7169 27.2222 41.8526 27.0508 44.5C27.1365 51.5036 31.0652 57.9099 37.3865 60.9857ZM63.8659 44.5C63.9508 39.9732 61.9016 36.3857 61.7303 35.8732C61.9016 39.3758 61.3883 41.1687 60.791 43.1339L54.8115 60.3026C62.3284 55.775 63.7795 49.0268 63.9508 44.5H63.8659ZM44.9035 43.7313L41.999 35.7875L39.8633 35.6169C39.0097 35.0187 39.5214 34.0794 40.1196 34.0794C43.9633 34.3357 46.0982 34.3357 49.9428 34.0794C50.8829 34.0794 51.1383 35.4464 50.0277 35.6169L47.9777 35.7875L54.6393 55.4331L57.7992 44.6706C57.9706 39.9732 56.6885 39.4607 54.9805 36.0438C53.6135 33.3956 55.0662 30.8331 57.7143 30.7482C55.5779 28.6982 51.2224 26.1357 45.4992 26.05C39.7761 25.9643 33.7117 28.8687 30.1242 34.3357L36.4456 34.1651C37.2144 34.5071 36.8724 35.6169 36.4456 35.7026L34.225 35.8732L40.8875 55.8607L44.9035 43.7313Z"
                          fill="#21759B"
                        ></path>
                      </g>
                      <defs>
                        <clippath id="clip0_4061_21597">
                          <rect
                            width="41"
                            height="41"
                            fill="white"
                            transform="translate(25 24)"
                          ></rect>
                        </clippath>
                      </defs>
                    </svg>
                  </i>
                  <h5>WordPress</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#EFEFEF"
                      ></rect>
                      <g clipPath="url(#clip0_4061_21566)">
                        <path
                          d="M55.8284 45.7405C55.8859 51.9333 61.2611 53.9941 61.3206 54.0204C61.2752 54.1658 60.4618 56.9573 58.4887 59.8407C56.7831 62.3336 55.0129 64.8173 52.2243 64.8687C49.4843 64.9192 48.6032 63.2439 45.4705 63.2439C42.3388 63.2439 41.3599 64.8173 38.7661 64.9192C36.0744 65.0211 34.0247 62.2235 32.3049 59.7398C28.7908 54.6592 26.1052 45.3833 29.7112 39.1219C31.5026 36.0125 34.704 34.0434 38.1788 33.993C40.8219 33.9425 43.3168 35.7712 44.9326 35.7712C46.5474 35.7712 49.5791 33.5721 52.7663 33.895C54.1006 33.9506 57.8459 34.434 60.2508 37.9542C60.057 38.0744 55.7819 40.5631 55.8284 45.7405ZM50.6787 30.5338C52.1078 28.804 53.0696 26.396 52.8072 24C50.7474 24.0828 48.2565 25.3726 46.7791 27.1015C45.4549 28.6324 44.2953 31.0829 44.6082 33.4314C46.9042 33.609 49.2496 32.2647 50.6787 30.5338Z"
                          fill="#A7A9AC"
                        ></path>
                      </g>
                      <defs>
                        <clippath id="clip0_4061_21566">
                          <rect
                            width="33.3206"
                            height="41"
                            fill="white"
                            transform="translate(28 24)"
                          ></rect>
                        </clippath>
                      </defs>
                    </svg>
                  </i>
                  <h5>iOS</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#E5FEF1"
                      ></rect>
                      <path
                        d="M58.4551 38.6418L63.1889 30.4415C63.4561 29.9818 63.2946 29.3978 62.841 29.1307C62.3875 28.8636 61.7974 29.0189 61.5365 29.4786L56.7405 37.7845C53.0815 36.1134 48.9627 35.1815 44.5333 35.1815C40.1039 35.1815 35.9851 36.1134 32.326 37.7845L27.5301 29.4786C27.263 29.0189 26.679 28.8636 26.2193 29.1307C25.7596 29.3978 25.6043 29.9818 25.8714 30.4415L30.6052 38.6418C22.4422 43.065 16.9132 51.3274 16 61H73.0666C72.1533 51.3274 66.6244 43.065 58.4551 38.6418ZM31.4315 52.9861C30.1082 52.9861 29.0397 51.9113 29.0397 50.5943C29.0397 49.2711 30.1144 48.2026 31.4315 48.2026C32.7547 48.2026 33.8232 49.2773 33.8232 50.5943C33.8294 51.9113 32.7547 52.9861 31.4315 52.9861ZM57.6289 52.9861C56.3057 52.9861 55.2371 51.9113 55.2371 50.5943C55.2371 49.2711 56.3119 48.2026 57.6289 48.2026C58.9521 48.2026 60.0206 49.2773 60.0206 50.5943C60.0269 51.9113 58.9521 52.9861 57.6289 52.9861Z"
                        fill="#32DE84"
                      ></path>
                    </svg>
                  </i>
                  <h5>Android</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#FFF9F2"
                      ></rect>
                      <path
                        d="M33.3486 40.6766C33.3486 41.3272 33.4197 41.8547 33.544 42.2415C33.6861 42.6283 33.8638 43.0503 34.1124 43.5074C34.2013 43.6481 34.2368 43.7887 34.2368 43.9118C34.2368 44.0876 34.1302 44.2634 33.8993 44.4393L32.7802 45.1777C32.6203 45.2832 32.4605 45.336 32.3184 45.336C32.1407 45.336 31.9631 45.2481 31.7855 45.0898C31.5368 44.8261 31.3236 44.5448 31.146 44.2634C30.9684 43.9645 30.7907 43.6305 30.5953 43.2261C29.2098 44.8437 27.469 45.6525 25.373 45.6525C23.8809 45.6525 22.6907 45.2305 21.8203 44.3865C20.9499 43.5426 20.5059 42.4173 20.5059 41.0107C20.5059 39.5162 21.0388 38.303 22.1223 37.3887C23.2059 36.4744 24.6447 36.0173 26.4743 36.0173C27.0782 36.0173 27.6999 36.07 28.3572 36.158C29.0144 36.2459 29.6894 36.3865 30.3999 36.5448V35.2612C30.3999 33.925 30.1157 32.9931 29.5651 32.4481C28.9966 31.903 28.0374 31.6393 26.6697 31.6393C26.048 31.6393 25.4085 31.7096 24.7513 31.8678C24.094 32.0261 23.4545 32.2195 22.8328 32.4656C22.5486 32.5887 22.3355 32.659 22.2111 32.6942C22.0868 32.7294 21.998 32.747 21.9269 32.747C21.6782 32.747 21.5539 32.5711 21.5539 32.2019V31.3404C21.5539 31.059 21.5894 30.8481 21.6782 30.725C21.767 30.6019 21.9269 30.4788 22.1756 30.3558C22.7973 30.0393 23.5434 29.7755 24.4138 29.5645C25.2841 29.336 26.2078 29.2305 27.1848 29.2305C29.2986 29.2305 30.844 29.7052 31.8388 30.6547C32.8157 31.6041 33.3131 33.0459 33.3131 34.9799V40.6766H33.3486ZM26.1368 43.3492C26.723 43.3492 27.3269 43.2437 27.9664 43.0327C28.6059 42.8217 29.1743 42.4349 29.6539 41.9074C29.9381 41.5733 30.1513 41.2041 30.2578 40.7821C30.3644 40.3601 30.4355 39.8503 30.4355 39.2525V38.514C29.9203 38.3909 29.3697 38.2854 28.8013 38.2151C28.2328 38.1448 27.6822 38.1096 27.1315 38.1096C25.9414 38.1096 25.071 38.3382 24.4848 38.8129C23.8986 39.2876 23.6144 39.9558 23.6144 40.8349C23.6144 41.6612 23.8276 42.2766 24.2716 42.6986C24.698 43.1382 25.3197 43.3492 26.1368 43.3492ZM40.4006 45.2481C40.0809 45.2481 39.8677 45.1953 39.7256 45.0722C39.5835 44.9667 39.4592 44.7206 39.3526 44.3865L35.1782 30.7953C35.0716 30.4437 35.0184 30.2151 35.0184 30.092C35.0184 29.8107 35.1605 29.6525 35.4447 29.6525H37.1855C37.523 29.6525 37.7539 29.7052 37.8782 29.8283C38.0203 29.9338 38.1269 30.1799 38.2335 30.514L41.2177 42.1536L43.9888 30.514C44.0776 30.1623 44.1841 29.9338 44.3263 29.8283C44.4684 29.7228 44.717 29.6525 45.0368 29.6525H46.4578C46.7953 29.6525 47.0263 29.7052 47.1684 29.8283C47.3105 29.9338 47.4348 30.1799 47.5059 30.514L50.3124 42.2942L53.3855 30.514C53.492 30.1623 53.6164 29.9338 53.7407 29.8283C53.8828 29.7228 54.1138 29.6525 54.4335 29.6525H56.0855C56.3697 29.6525 56.5295 29.7931 56.5295 30.092C56.5295 30.1799 56.5118 30.2678 56.494 30.3733C56.4763 30.4788 56.4407 30.6195 56.3697 30.8129L52.0888 44.4041C51.9822 44.7558 51.8578 44.9843 51.7157 45.0898C51.5736 45.1953 51.3427 45.2656 51.0407 45.2656H49.5131C49.1756 45.2656 48.9447 45.2129 48.8026 45.0898C48.6605 44.9667 48.5361 44.7382 48.4651 44.3865L45.7118 33.0459L42.9763 44.3689C42.8874 44.7206 42.7809 44.9492 42.6388 45.0722C42.4966 45.1953 42.248 45.2481 41.9282 45.2481H40.4006ZM63.2263 45.7228C62.3026 45.7228 61.3789 45.6173 60.4907 45.4063C59.6026 45.1953 58.9098 44.9667 58.448 44.703C58.1638 44.5448 57.9684 44.3689 57.8973 44.2107C57.8263 44.0525 57.7907 43.8766 57.7907 43.7184V42.8217C57.7907 42.4525 57.9328 42.2766 58.1993 42.2766C58.3059 42.2766 58.4124 42.2942 58.519 42.3294C58.6256 42.3645 58.7855 42.4349 58.9631 42.5052C59.567 42.7689 60.2243 42.9799 60.917 43.1206C61.6276 43.2612 62.3203 43.3316 63.0309 43.3316C64.1499 43.3316 65.0203 43.1382 65.6243 42.7514C66.2282 42.3645 66.548 41.8019 66.548 41.081C66.548 40.5887 66.3881 40.1843 66.0684 39.8503C65.7486 39.5162 65.1447 39.2173 64.2743 38.936L61.6986 38.1448C60.4019 37.7404 59.4427 37.1426 58.8565 36.3514C58.2703 35.5777 57.9684 34.7162 57.9684 33.8019C57.9684 33.0634 58.1282 32.4129 58.448 31.8503C58.7677 31.2876 59.194 30.7953 59.7269 30.4085C60.2598 30.0041 60.8638 29.7052 61.5743 29.4942C62.2848 29.2832 63.0309 29.1953 63.8124 29.1953C64.2032 29.1953 64.6118 29.2129 65.0026 29.2656C65.4111 29.3184 65.7841 29.3887 66.1572 29.459C66.5124 29.547 66.8499 29.6349 67.1697 29.7404C67.4894 29.8459 67.7381 29.9514 67.9157 30.0569C68.1644 30.1975 68.342 30.3382 68.4486 30.4964C68.5552 30.6371 68.6085 30.8305 68.6085 31.0766V31.903C68.6085 32.2722 68.4664 32.4656 68.1999 32.4656C68.0578 32.4656 67.8269 32.3953 67.5249 32.2547C66.5124 31.7975 65.3756 31.5689 64.1144 31.5689C63.1019 31.5689 62.3026 31.7272 61.7519 32.0612C61.2013 32.3953 60.917 32.9052 60.917 33.6261C60.917 34.1184 61.0947 34.5404 61.4499 34.8744C61.8052 35.2085 62.4624 35.5426 63.4039 35.8415L65.9263 36.6327C67.2052 37.0371 68.1289 37.5997 68.6795 38.3206C69.2302 39.0415 69.4967 39.8678 69.4967 40.7821C69.4967 41.5382 69.3368 42.2239 69.0348 42.8217C68.7151 43.4195 68.2888 43.947 67.7381 44.3689C67.1874 44.8085 66.5302 45.125 65.7664 45.3536C64.967 45.5997 64.1322 45.7228 63.2263 45.7228Z"
                        fill="#252F3E"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M66.5828 54.2708C60.7388 58.5434 52.248 60.8115 44.9473 60.8115C34.7157 60.8115 25.4966 57.0665 18.5335 50.8423C17.9828 50.35 18.4802 49.6818 19.1374 50.0687C26.669 54.3939 35.9591 57.0137 45.569 57.0137C52.0526 57.0137 59.1756 55.6774 65.7302 52.9346C66.7072 52.495 67.542 53.5675 66.5828 54.2708Z"
                        fill="#FF9900"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M69.0161 51.5274C68.2701 50.5779 64.078 51.0703 62.1773 51.2988C61.6089 51.3692 61.5201 50.8768 62.0352 50.5076C65.3747 48.1867 70.8635 48.8549 71.503 49.6285C72.1424 50.4197 71.3253 55.8527 68.199 58.4549C67.7194 58.8593 67.2576 58.6483 67.4707 58.1208C68.1812 56.3801 69.7622 52.4593 69.0161 51.5274Z"
                        fill="#FF9900"
                      ></path>
                    </svg>
                  </i>
                  <h5>AWS</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#FFF5E2"
                      ></rect>
                      <path
                        d="M30.0234 55.7954L35.1014 23.7849C35.1716 23.2768 35.6631 22.9304 36.1779 23.0227C36.4587 23.0689 36.7161 23.2537 36.8565 23.5077L42.0983 33.1617L44.181 29.2354C44.415 28.7735 44.9766 28.6119 45.4447 28.8428C45.6085 28.9352 45.7489 29.0738 45.8425 29.2354L59.9766 55.7954H30.0234Z"
                        fill="#FFA000"
                      ></path>
                      <path
                        d="M47.5507 43.3238L42.0983 33.1387L30.0234 55.7954L47.5507 43.3238Z"
                        fill="#F57C00"
                      ></path>
                      <path
                        d="M59.9766 55.7953L56.0921 32.0762C55.9985 31.5681 55.5305 31.2447 55.0156 31.314C54.8284 31.3371 54.6412 31.4295 54.5008 31.5681L30.0234 55.7953L43.5726 63.3014C44.415 63.7633 45.4681 63.7633 46.3105 63.3014L59.9766 55.7953Z"
                        fill="#FFCA28"
                      ></path>
                      <path
                        d="M56.1154 32.0994C56.0218 31.5913 55.5538 31.268 55.039 31.3373C54.8518 31.3604 54.6646 31.4528 54.5242 31.5913L49.6568 36.3952L45.8424 29.2125C45.6084 28.7506 45.0468 28.5889 44.5788 28.8199C44.415 28.9123 44.2746 29.0508 44.181 29.2125L42.0983 33.1387L36.8565 23.4848C36.6225 23.046 36.0374 22.8612 35.5928 23.1153C35.3354 23.2538 35.1482 23.5079 35.1014 23.785L30.0234 55.7955H30L30.0234 55.8186L30.1638 55.8879L49.6568 36.6262L54.5242 31.8223C54.8986 31.4528 55.4836 31.4528 55.858 31.8223C55.9984 31.9609 56.092 32.1225 56.1154 32.3304L59.9532 55.8186L60 55.7955L56.1154 32.0994ZM30.0702 55.7493L35.1014 24.016C35.1716 23.5079 35.663 23.1615 36.1778 23.2538C36.4587 23.3 36.7161 23.4848 36.8565 23.7388L42.0983 33.3928L44.181 29.4665C44.415 29.0046 44.9766 28.843 45.4446 29.0739C45.6084 29.1663 45.7488 29.3049 45.8424 29.4665L49.5866 36.4876L30.0702 55.7493Z"
                        fill="white"
                        fillOpacity="0.2"
                      ></path>
                      <path
                        opacity="0.2"
                        d="M46.3105 63.0669C45.4681 63.5289 44.415 63.5289 43.5726 63.0669L30.0468 55.584L30.0234 55.7918L43.5726 63.2979C44.415 63.7598 45.4681 63.7598 46.3105 63.2979L59.9766 55.7918L59.9532 55.584L46.3105 63.0669Z"
                        fill="#A52714"
                      ></path>
                      <path
                        d="M56.1155 32.0994C56.0219 31.5913 55.5539 31.268 55.039 31.3373C54.8518 31.3604 54.6646 31.4528 54.5242 31.5913L49.6568 36.3952L45.8425 29.2125C45.6085 28.7506 45.0468 28.5889 44.5788 28.8199C44.415 28.9123 44.2746 29.0508 44.181 29.2125L42.0983 33.1387L36.8565 23.4848C36.6225 23.046 36.0375 22.8612 35.5929 23.1153C35.3354 23.2538 35.1482 23.5079 35.1014 23.785L30.0234 55.7955L43.5726 63.3016C44.415 63.7635 45.4681 63.7635 46.3105 63.3016L59.9766 55.7955L56.1155 32.0994Z"
                        fill="url(#paint0_linear_4061_21535)"
                      ></path>
                      <defs>
                        <lineargradient
                          id="paint0_linear_4061_21535"
                          x1="29.217"
                          y1="30.1531"
                          x2="60.0901"
                          y2="61.4344"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="white" stopOpacity="0.1"></stop>
                          <stop
                            offset="1"
                            stopColor="white"
                            stopOpacity="0"
                          ></stop>
                        </lineargradient>
                      </defs>
                    </svg>
                  </i>
                  <h5>Firebase</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#F0F3E8"
                      ></rect>
                      <path
                        d="M45.0801 25.1152L46.1741 27.1433C46.4201 27.5176 46.6866 27.8489 47.0005 28.1574C47.9207 29.0543 48.7784 30.0115 49.5678 31.0225C51.4216 33.4249 52.672 36.0928 53.5649 38.9782C54.1005 40.7408 54.3913 42.5489 54.413 44.3772C54.5027 49.8433 52.6041 54.5367 48.7761 58.4374C48.1534 59.056 47.4808 59.6235 46.7647 60.1343C46.3855 60.1343 46.2062 59.8472 46.0499 59.583C45.7652 59.093 45.5758 58.5548 45.4913 57.9962C45.3568 57.3349 45.2684 56.6736 45.3119 55.9908V55.6823C45.2812 55.6165 44.9468 25.2708 45.0801 25.1152Z"
                        fill="#599636"
                      ></path>
                      <path
                        d="M45.0794 25.0435C45.0346 24.955 44.9898 25.022 44.9449 25.065C44.9667 25.5075 44.8104 25.902 44.5657 26.2788C44.2967 26.6531 43.9405 26.9401 43.5831 27.2486C41.5973 28.9455 40.0344 30.9951 38.7827 33.2874C37.1172 36.3726 36.2589 39.679 36.0155 43.1599C35.904 44.4155 36.4177 48.846 36.8187 50.1243C37.9128 53.518 39.8781 56.3616 42.4237 58.8297C43.0488 59.424 43.7176 59.9753 44.4094 60.5051C44.6105 60.5051 44.6323 60.3281 44.6784 60.1966C44.7666 59.9152 44.8338 59.6278 44.8796 59.3368L45.328 56.0316L45.0794 25.0435Z"
                        fill="#6CAC48"
                      ></path>
                      <path
                        d="M46.1743 61.4692C46.2191 60.9634 46.4651 60.5437 46.7328 60.1251C46.4638 60.0151 46.2639 59.7964 46.1076 59.5524C45.9729 59.3213 45.8613 59.0778 45.7746 58.8253C45.462 57.8998 45.3953 56.9287 45.3057 55.9829V55.4102C45.1942 55.4987 45.1711 56.2472 45.1711 56.3585C45.106 57.3581 44.9715 58.3521 44.7689 59.3336C44.7023 59.7306 44.6574 60.1264 44.4102 60.4792C44.4102 60.5234 44.4102 60.5677 44.4319 60.6334C44.8342 61.8017 44.9444 62.9915 45.0123 64.2041V64.6467C45.0123 65.1752 44.9905 65.0639 45.4351 65.2409C45.6144 65.3067 45.8143 65.3294 45.9936 65.4609C46.1281 65.4609 46.1499 65.3509 46.1499 65.2624L46.0833 64.5354V62.5073C46.0615 62.1532 46.1281 61.8017 46.173 61.4705L46.1743 61.4692Z"
                        fill="#C2BFBF"
                      ></path>
                    </svg>
                  </i>
                  <h5>MongoDB</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#EFEFF2"
                      ></rect>
                      <g clipPath="url(#clip0_4061_21366)">
                        <path
                          d="M63.8485 49.5469C63.6147 48.8249 63.0021 48.3221 62.2099 48.2015C61.8364 48.1446 61.4086 48.1688 60.9023 48.2752C60.02 48.4608 59.3653 48.5314 58.8876 48.5451C60.6909 45.4417 62.1572 41.9027 63.0013 38.5713C64.3663 33.1845 63.6369 30.7305 62.7845 29.6205C60.5288 26.6825 57.2377 25.1042 53.2673 25.0559C51.1493 25.0295 49.2899 25.4557 48.32 25.7623C47.4169 25.5998 46.4458 25.5091 45.427 25.4924C43.517 25.4613 41.8295 25.8857 40.3876 26.758C39.5893 26.4828 38.3081 26.0949 36.8285 25.8474C33.3487 25.265 30.544 25.7188 28.4926 27.196C26.0085 28.9846 24.8569 32.0922 25.0699 36.4325C25.1375 37.8106 25.8937 42.0033 27.0845 45.9796C27.7688 48.2651 28.4985 50.1631 29.2534 51.6212C30.3239 53.6889 31.4694 54.9065 32.7553 55.3438C33.476 55.5885 34.7856 55.7599 36.1629 54.5906C36.3375 54.8061 36.5705 55.0203 36.8796 55.2192C37.2721 55.4716 37.7522 55.6778 38.2316 55.8C39.9593 56.2402 41.5777 56.1301 42.9584 55.513C42.9669 55.7633 42.9735 56.0025 42.9789 56.209C42.9881 56.544 42.9972 56.8724 43.0093 57.1796C43.0911 59.2564 43.2297 60.8712 43.6404 62.0011C43.663 62.0632 43.6933 62.1579 43.7253 62.2584C43.9302 62.8979 44.2728 63.9684 45.1445 64.8068C46.0471 65.6753 47.139 65.9417 48.139 65.9417C48.6405 65.9417 49.119 65.8746 49.5387 65.783C51.0347 65.4561 52.7338 64.9582 53.9629 63.1743C55.125 61.4879 55.6899 58.9478 55.7921 54.9456C55.8054 54.8324 55.8176 54.7243 55.8293 54.6214L55.8537 54.4099L56.1274 54.4344L56.198 54.4392C57.7217 54.51 59.5849 54.1806 60.7291 53.6389C61.6333 53.2112 64.5307 51.6519 63.8485 49.5469Z"
                          fill="black"
                        ></path>
                        <path
                          d="M61.2431 49.9584C56.7124 50.9111 56.4008 49.3475 56.4008 49.3475C61.1844 42.1122 63.1843 32.928 61.4587 30.6802C56.7506 24.5487 48.601 27.4485 48.465 27.5237L48.4212 27.5318C47.5261 27.3423 46.5244 27.2296 45.3984 27.2108C43.3485 27.1766 41.7934 27.7586 40.6133 28.6708C40.6133 28.6708 26.0751 22.5658 26.7514 36.3488C26.8952 39.281 30.8744 58.5352 35.6205 52.7196C37.3553 50.5929 39.0315 48.7948 39.0315 48.7948C39.8639 49.3585 40.8606 49.6461 41.9053 49.5428L41.9865 49.4726C41.9612 49.7366 41.9728 49.9949 42.019 50.3006C40.7963 51.6931 41.1557 51.9375 38.7114 52.4504C36.2381 52.97 37.6911 53.8949 38.6397 54.1369C39.7897 54.4299 42.4503 54.8451 44.2479 52.2799L44.1763 52.5727C44.6553 52.9638 44.9917 55.1167 44.9353 57.0685C44.8789 59.0202 44.8413 60.3602 45.2187 61.4068C45.5963 62.4534 45.9725 64.8084 49.1857 64.1066C51.8704 63.5201 53.2618 62.0003 53.4554 59.4651C53.5927 57.6628 53.9036 57.9293 53.9231 56.3179L54.1725 55.5551C54.46 53.112 54.2182 52.3237 55.8722 52.6904L56.2744 52.7264C57.4916 52.7828 59.0851 52.5267 60.0204 52.0837C62.0341 51.1311 63.2284 49.5405 61.2428 49.9584H61.2431Z"
                          fill="#336791"
                        ></path>
                        <path
                          d="M41.4643 37.6607C41.056 37.6028 40.6863 37.6564 40.4992 37.8008C40.3941 37.882 40.3615 37.9761 40.3526 38.0409C40.3292 38.2124 40.4471 38.4022 40.5196 38.5C40.7247 38.7771 41.0242 38.9675 41.3206 39.0094C41.3636 39.0156 41.4064 39.0184 41.4489 39.0184C41.9433 39.0184 42.3928 38.626 42.4324 38.3364C42.482 37.9736 41.9654 37.7318 41.4643 37.6609M54.99 37.6722C54.951 37.3879 54.4546 37.3068 53.9836 37.3736C53.5132 37.4404 53.057 37.6568 53.0951 37.9418C53.1256 38.1634 53.5182 38.5417 53.9828 38.5417C54.0221 38.5417 54.0618 38.539 54.1017 38.5333C54.4118 38.4895 54.6394 38.2887 54.7476 38.173C54.9121 37.9966 55.0075 37.8 54.99 37.6722Z"
                          fill="white"
                        ></path>
                        <path
                          d="M62.7504 49.8465C62.5777 49.314 62.0216 49.1427 61.0978 49.3371C58.3548 49.9142 57.3725 49.5145 57.05 49.2724C59.1821 45.9617 60.936 41.9596 61.8822 38.2257C62.3304 36.457 62.578 34.8143 62.5982 33.4755C62.6206 32.006 62.375 30.9261 61.8686 30.2664C59.8269 27.6071 56.8303 26.1807 53.203 26.1415C50.7093 26.113 48.6024 26.7635 48.194 26.9464C47.3338 26.7284 46.3962 26.5945 45.3753 26.5774C43.5033 26.5465 41.8851 27.0034 40.5454 27.9346C39.9634 27.7138 38.4595 27.1876 36.6203 26.8855C33.4405 26.3638 30.9138 26.7591 29.1106 28.0612C26.9591 29.615 25.9658 32.3925 26.1582 36.3163C26.2229 37.6364 26.9609 41.6975 28.1254 45.5866C29.6583 50.7055 31.3246 53.6034 33.0778 54.1995C33.283 54.2692 33.5196 54.318 33.7806 54.318C34.4201 54.318 35.2042 54.0242 36.02 53.0244C37.0151 51.8077 38.0444 50.6205 39.1067 49.4643C39.7959 49.8414 40.553 50.0519 41.3274 50.073C41.3289 50.0937 41.3309 50.1144 41.3327 50.1349C41.1994 50.2969 41.0689 50.4613 40.9412 50.6279C40.4046 51.3222 40.293 51.4668 38.5658 51.8292C38.0745 51.9326 36.7697 52.2067 36.7505 53.139C36.7298 54.1577 38.293 54.5856 38.4711 54.6309C39.0917 54.7893 39.6897 54.8674 40.2599 54.8674C41.6467 54.8674 42.8671 54.4028 43.8424 53.5038C43.8124 57.1354 43.9609 60.7138 44.3887 61.8041C44.7391 62.6967 45.595 64.878 48.2985 64.8778C48.6952 64.8778 49.1318 64.8308 49.6121 64.7258C52.4337 64.1093 53.659 62.8382 54.1329 60.0357C54.3866 58.5379 54.8218 54.9615 55.0266 53.0431C55.4586 53.1805 56.0148 53.2434 56.6161 53.2432C57.8702 53.2432 59.3173 52.9716 60.2249 52.5423C61.2443 52.0596 63.084 50.8754 62.7504 49.8465ZM56.0311 36.8831C56.0218 37.4494 55.9454 37.9636 55.8643 38.5002C55.777 39.0775 55.6868 39.6742 55.6641 40.3986C55.6417 41.1036 55.7281 41.8366 55.8116 42.5455C55.9804 43.9772 56.1536 45.4512 55.4832 46.9057C55.3718 46.7045 55.2726 46.4966 55.1861 46.2831C55.1028 46.0772 54.9218 45.7464 54.6712 45.2886C53.6963 43.5066 51.4134 39.3334 52.5821 37.6305C52.9302 37.1236 53.8136 36.6025 56.0311 36.8831ZM53.3432 27.2883C56.5933 27.3615 59.1642 28.6008 60.9844 30.9718C62.3805 32.7903 60.8432 41.0651 56.3928 48.2039C56.348 48.1458 56.3031 48.088 56.2578 48.0304L56.2015 47.9587C57.3515 46.0227 57.1266 44.1072 56.9265 42.409C56.8442 41.7121 56.7665 41.0538 56.7863 40.4354C56.8067 39.7801 56.8917 39.218 56.974 38.6745C57.075 38.0047 57.1778 37.3117 57.1495 36.4947C57.1707 36.409 57.1792 36.3077 57.1681 36.1876C57.0957 35.4041 56.2182 33.0594 54.4297 30.9373C53.4513 29.7765 52.0246 28.4775 50.0766 27.6014C50.9145 27.4244 52.0603 27.2593 53.3432 27.2883ZM35.1567 52.2927C34.2579 53.3943 33.6372 53.1831 33.4331 53.1139C32.1031 52.6617 30.5599 49.7963 29.1993 45.2526C28.022 41.321 27.334 37.3676 27.2794 36.259C27.1076 32.7529 27.9414 30.3095 29.7578 28.9963C32.7139 26.8596 37.5739 28.1385 39.5268 28.7872C39.4988 28.8154 39.4695 28.8418 39.4418 28.8706C36.2371 32.1695 36.3131 37.8058 36.3211 38.1504C36.3207 38.2833 36.3317 38.4715 36.3466 38.7304C36.4018 39.6784 36.5045 41.4428 36.2303 43.4409C35.9755 45.2976 36.5371 47.115 37.7706 48.427C37.8972 48.5614 38.0303 48.6893 38.1693 48.8103C37.6202 49.4097 36.4269 50.7352 35.1567 52.2927ZM38.5812 47.6352C37.587 46.5777 37.1355 45.1068 37.3422 43.5993C37.6317 41.4886 37.5249 39.6503 37.4674 38.6627C37.4594 38.5245 37.4522 38.4033 37.4481 38.3078C37.9162 37.8847 40.0858 36.6998 41.633 37.0612C42.3389 37.226 42.7692 37.716 42.948 38.5589C43.8736 42.923 43.0705 44.7419 42.4252 46.2036C42.2922 46.5047 42.1665 46.7893 42.0592 47.0838L41.9761 47.3114C41.7655 47.8869 41.5696 48.422 41.4482 48.9301C40.3912 48.927 39.3631 48.4668 38.5812 47.635V47.6352ZM38.7435 53.5206C38.4348 53.442 38.1573 53.3055 37.9944 53.1923C38.1304 53.1271 38.3725 53.0383 38.7924 52.9501C40.8242 52.5238 41.138 52.2229 41.8232 51.336C41.9803 51.1326 42.1584 50.9021 42.4051 50.6214L42.4054 50.6211C42.7727 50.2018 42.9407 50.2729 43.2454 50.4018C43.4923 50.5058 43.7329 50.8214 43.8304 51.1686C43.8765 51.3326 43.9283 51.6438 43.7588 51.886C42.3274 53.929 40.2415 53.9028 38.7435 53.5206ZM49.3769 63.6068C46.8913 64.1497 46.0112 62.8569 45.4312 61.3791C45.0569 60.425 44.8729 56.1226 45.0034 51.3713C45.0051 51.3081 44.9963 51.247 44.9792 51.1896C44.9639 51.0761 44.9407 50.9639 44.9097 50.8538C44.7156 50.1625 44.2426 49.5842 43.6751 49.3444C43.4497 49.2493 43.0359 49.0746 42.5387 49.2042C42.6447 48.7589 42.8286 48.2559 43.028 47.7113L43.1116 47.4822C43.2058 47.224 43.324 46.9564 43.4489 46.6732C44.1243 45.1439 45.0491 43.0492 44.0453 38.3172C43.6694 36.5447 42.4137 35.6791 40.5104 35.8802C39.3693 36.0006 38.3253 36.4699 37.8046 36.739C37.6926 36.7967 37.5902 36.8526 37.4946 36.907C37.6399 35.1212 38.1889 31.7838 40.2428 29.6722C41.5361 28.3429 43.2583 27.6863 45.3567 27.7217C49.4913 27.7907 52.1427 29.9535 53.639 31.756C54.9285 33.309 55.6267 34.8735 55.9053 35.7173C53.8098 35.5001 52.3846 35.9217 51.6622 36.9745C50.0905 39.2647 52.522 43.7097 53.6907 45.846C53.905 46.2374 54.09 46.5758 54.1482 46.7196C54.5287 47.6597 55.0214 48.2874 55.3811 48.7455C55.4914 48.8859 55.5983 49.0221 55.6797 49.141C55.045 49.3275 53.905 49.7584 54.0089 51.9124C53.9251 52.9932 53.3293 58.0534 53.0266 59.8413C52.627 62.2032 51.7743 63.0829 49.3769 63.607V63.6068ZM59.7521 51.5043C59.1031 51.8113 58.0171 52.0416 56.9854 52.0912C55.8459 52.1455 55.2658 51.961 55.1293 51.8475C55.0653 50.5052 55.5554 50.365 56.0741 50.2165C56.1556 50.1932 56.2351 50.1704 56.3119 50.1431C56.3596 50.1827 56.4118 50.222 56.4691 50.2605C57.385 50.8767 59.0186 50.9431 61.3249 50.4579L61.3502 50.4527C61.0391 50.7492 60.5068 51.147 59.7521 51.5043Z"
                          fill="white"
                        ></path>
                      </g>
                      <defs>
                        <clippath id="clip0_4061_21366">
                          <rect
                            width="39"
                            height="41"
                            fill="white"
                            transform="translate(25 25)"
                          ></rect>
                        </clippath>
                      </defs>
                    </svg>
                  </i>
                  <h5>PostgreSQL</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#F0F1F1"
                      ></rect>
                      <path
                        d="M62.7654 56.2968C60.5346 56.2409 58.8056 56.4653 57.3556 57.082C56.9373 57.2501 56.268 57.2503 56.2122 57.7829C56.4354 58.0073 56.4632 58.3718 56.6584 58.6801C56.9933 59.2407 57.5786 59.9979 58.1085 60.3904C58.694 60.839 59.2797 61.2875 59.8931 61.6801C60.9807 62.353 62.2077 62.7454 63.2673 63.4184C63.881 63.8106 64.4941 64.3156 65.1076 64.7361C65.4145 64.9602 65.6095 65.3248 66 65.465V65.3809C65.8048 65.1285 65.749 64.7641 65.5539 64.4837C65.2752 64.2033 64.9962 63.951 64.7174 63.6706C63.9086 62.5773 62.9048 61.624 61.8172 60.839C60.925 60.2221 58.9729 59.381 58.6104 58.3436C58.6104 58.3436 58.5824 58.3157 58.5546 58.2877C59.1681 58.2316 59.8931 58.0073 60.4788 57.839C61.4269 57.5866 62.2913 57.6427 63.2673 57.3905C63.7134 57.2783 64.1596 57.1381 64.6057 56.9979V56.7457C64.104 56.2409 63.7414 55.5681 63.2115 55.0915C61.7894 53.8576 60.2277 52.6522 58.6104 51.643C57.7458 51.0823 56.6304 50.7176 55.7103 50.2412C55.3758 50.0727 54.8179 49.9888 54.6229 49.7084C54.1208 49.0916 53.8419 48.2786 53.4794 47.5495C52.6711 46.0074 51.8899 44.2974 51.1928 42.6713C50.6911 41.5778 50.3843 40.4843 49.7708 39.475C46.8986 34.7088 43.7754 31.8211 38.9791 28.9893C37.9473 28.4006 36.7205 28.1482 35.4098 27.8399C34.7129 27.8117 34.0156 27.7558 33.3184 27.7276C32.8724 27.5314 32.4261 26.9988 32.0356 26.7464C30.4465 25.7369 26.3471 23.5503 25.1759 26.438C24.423 28.2604 26.2913 30.0546 26.9326 30.98C27.4069 31.6248 28.0202 32.3537 28.3549 33.0827C28.5501 33.559 28.6058 34.064 28.801 34.5686C29.2473 35.802 29.6654 37.176 30.2511 38.3256C30.5579 38.9143 30.8924 39.5312 31.2829 40.0637C31.5059 40.3721 31.8962 40.5124 31.98 41.0171C31.5897 41.5778 31.5617 42.4189 31.3385 43.1198C30.3347 46.2879 30.7251 50.213 32.1472 52.54C32.5933 53.2408 33.6531 54.7831 35.0752 54.1943C36.33 53.6896 36.0512 52.0915 36.4136 50.6897C36.4974 50.353 36.4416 50.1289 36.6089 49.9047C36.609 49.9327 36.6089 49.9608 36.6089 49.9608C36.9993 50.7458 37.3896 51.5028 37.7521 52.2878C38.6166 53.6615 40.1223 55.0914 41.3772 56.0448C42.0467 56.5492 42.5764 57.4185 43.4129 57.727V57.6427H43.3571C43.1897 57.3903 42.9389 57.2783 42.7158 57.082C42.2139 56.5774 41.656 55.9605 41.2657 55.3998C40.0947 53.8296 39.0627 52.0915 38.1426 50.2971C37.6965 49.428 37.306 48.4747 36.9435 47.6057C36.7761 47.269 36.7761 46.7646 36.4973 46.5964C36.079 47.2131 35.4656 47.7458 35.1588 48.5029C34.6293 49.7084 34.5733 51.1943 34.378 52.7363C34.2666 52.7645 34.3222 52.7363 34.2664 52.7924C33.3743 52.568 33.0674 51.643 32.7327 50.8578C31.8962 48.8673 31.7568 45.6711 32.4819 43.3722C32.6771 42.7833 33.5137 40.933 33.179 40.3723C33.0118 39.8395 32.4539 39.5312 32.1472 39.1106C31.7847 38.5778 31.3943 37.9051 31.1434 37.3162C30.4741 35.7462 30.1394 34.0079 29.4145 32.4378C29.0798 31.7087 28.4943 30.9519 28.0202 30.2791C27.4905 29.5221 26.9048 28.9893 26.4865 28.0921C26.3473 27.7838 26.1519 27.2791 26.3749 26.9427C26.4307 26.7184 26.5422 26.6343 26.7654 26.5782C27.1279 26.2697 28.1597 26.6623 28.5221 26.8304C29.5539 27.2508 30.4183 27.6436 31.2828 28.2323C31.6731 28.5126 32.0914 29.0454 32.5933 29.1856H33.179C34.0714 29.3817 35.0752 29.2417 35.9117 29.4939C37.3898 29.9704 38.7281 30.6715 39.9273 31.4285C43.5803 33.7555 46.5917 37.064 48.6275 41.0171C48.9622 41.6617 49.1014 42.2507 49.4083 42.9235C49.994 44.2974 50.7189 45.6992 51.3044 47.0449C51.89 48.3625 52.4477 49.7084 53.2842 50.8019C53.7027 51.3904 55.3756 51.6989 56.1285 52.0074C56.6862 52.2597 57.5508 52.4841 58.0527 52.7924C59.0007 53.381 59.9489 54.0541 60.8412 54.6989C61.2875 55.0352 62.6816 55.7363 62.7654 56.2968L62.7654 56.2968Z"
                        fill="#00546B"
                      ></path>
                    </svg>
                  </i>
                  <h5>MySQL</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#EFE8F7"
                      ></rect>
                      <g clipPath="url(#clip0_4061_21374)">
                        <path d="M66 25H25V66H66V25Z" fill="#512BD4"></path>
                        <path
                          d="M32.3073 51.1938C32.0174 51.1938 31.771 51.0972 31.5681 50.904C31.3651 50.7058 31.2637 50.4705 31.2637 50.1981C31.2637 49.9206 31.3651 49.6829 31.5681 49.4848C31.771 49.2866 32.0174 49.1875 32.3073 49.1875C32.602 49.1875 32.8509 49.2866 33.0538 49.4848C33.2616 49.6829 33.3655 49.9206 33.3655 50.1981C33.3655 50.4705 33.2616 50.7058 33.0538 50.904C32.8509 51.0972 32.602 51.1938 32.3073 51.1938Z"
                          fill="white"
                        ></path>
                        <path
                          d="M43.897 51.031H42.0126L37.0481 43.1988C36.9225 43.0006 36.8186 42.795 36.7365 42.582H36.693C36.7316 42.8099 36.751 43.2979 36.751 44.0458V51.031H35.084V40.375H37.0915L41.8894 48.0214C42.0924 48.3385 42.2228 48.5565 42.2808 48.6753H42.3098C42.2615 48.393 42.2373 47.915 42.2373 47.2412V40.375H43.897V51.031Z"
                          fill="white"
                        ></path>
                        <path
                          d="M52.0142 51.031H46.1799V40.375H51.7823V41.8761H47.9049V44.893H51.4779V46.3866H47.9049V49.5373H52.0142V51.031Z"
                          fill="white"
                        ></path>
                        <path
                          d="M60.3049 41.8761H57.3189V51.031H55.5939V41.8761H52.6152V40.375H60.3049V41.8761Z"
                          fill="white"
                        ></path>
                      </g>
                      <defs>
                        <clippath id="clip0_4061_21374">
                          <rect
                            width="41"
                            height="41"
                            fill="white"
                            transform="translate(25 25)"
                          ></rect>
                        </clippath>
                      </defs>
                    </svg>
                  </i>
                  <h5>.NET</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#F3EFF4"
                      ></rect>
                      <g clipPath="url(#clip0_4061_21375)">
                        <path
                          d="M14.8711 45.0035C14.8711 53.9028 28.3602 61.1172 44.9993 61.1172C61.6383 61.1172 75.1276 53.9028 75.1276 45.0035C75.1276 36.1044 61.6383 28.8899 44.9993 28.8899C28.3602 28.8899 14.8711 36.1044 14.8711 45.0035Z"
                          fill="url(#paint0_radial_4061_21375)"
                        ></path>
                        <path
                          d="M45.0001 59.9219C60.9893 59.9219 73.9514 53.2431 73.9514 45.0046C73.9514 36.7661 60.9893 30.0873 45.0001 30.0873C29.011 30.0873 16.0488 36.7661 16.0488 45.0046C16.0488 53.2431 29.011 59.9219 45.0001 59.9219Z"
                          fill="#777BB3"
                        ></path>
                        <path
                          d="M31.2398 46.8531C32.5546 46.8531 33.5361 46.6066 34.1571 46.1207C34.7715 45.6397 35.1958 44.8065 35.4182 43.6441C35.6256 42.5577 35.5466 41.7991 35.1835 41.3897C34.8122 40.9716 34.0096 40.7595 32.7978 40.7595H30.6967L29.532 46.8531H31.2398ZM24.3678 54.3594C24.2703 54.3594 24.1777 54.3151 24.1157 54.2384C24.0536 54.1618 24.0284 54.061 24.047 53.9636L27.1339 37.8154C27.1638 37.6593 27.2984 37.5465 27.4549 37.5465H34.108C36.1989 37.5465 37.7552 38.1237 38.7334 39.2624C39.7169 40.407 40.0206 42.0069 39.636 44.0177C39.4795 44.8369 39.2104 45.5977 38.8361 46.2789C38.4613 46.9608 37.9661 47.5918 37.3638 48.1546C36.6428 48.8407 35.8269 49.3381 34.9407 49.6308C34.0686 49.9197 32.9486 50.0661 31.6119 50.0661H28.9179L28.1486 54.0904C28.1187 54.2466 27.9842 54.3594 27.8278 54.3594H24.3678Z"
                          fill="black"
                        ></path>
                        <path
                          d="M30.967 41.0954H32.7986C34.2611 41.0954 34.7691 41.4217 34.9417 41.6162C35.2281 41.939 35.2821 42.6197 35.0981 43.5846C34.8912 44.6649 34.5079 45.4308 33.9584 45.8609C33.3959 46.3012 32.4815 46.5243 31.2406 46.5243H29.9293L30.967 41.0954ZM34.1087 37.2177H27.4555C27.1426 37.2177 26.8735 37.4433 26.8138 37.7556L23.7269 53.9038C23.6896 54.0987 23.7399 54.3002 23.8641 54.4535C23.9883 54.6067 24.1733 54.6953 24.3686 54.6953H27.8284C28.1415 54.6953 28.4105 54.4697 28.4702 54.1574L29.1881 50.4021H31.6126C32.9837 50.4021 34.1379 50.2501 35.0429 49.9504C35.9736 49.6429 36.8299 49.1216 37.5878 48.401C38.2146 47.8147 38.7309 47.1566 39.1221 46.4448C39.5134 45.7327 39.7946 44.9386 39.9577 44.0846C40.3625 41.9681 40.0337 40.2731 38.9804 39.0473C37.9373 37.8333 36.2982 37.2177 34.1087 37.2177ZM29.1361 47.1891H31.2406C32.6355 47.1891 33.6746 46.9219 34.3573 46.3876C35.0401 45.8531 35.5006 44.9611 35.7399 43.7112C35.9688 42.5111 35.8646 41.6641 35.427 41.1708C34.989 40.6774 34.113 40.4307 32.7986 40.4307H30.428L29.1361 47.1891ZM34.1087 37.8824C36.1102 37.8824 37.5703 38.4165 38.488 39.4846C39.4057 40.5528 39.682 42.0437 39.3159 43.9579C39.1652 44.7464 38.9103 45.4673 38.5514 46.1205C38.1922 46.774 37.7231 47.3717 37.1433 47.9135C36.4525 48.5709 35.685 49.0393 34.8405 49.3183C33.9959 49.598 32.9203 49.7373 31.6126 49.7373H28.6491L27.8284 54.0306H24.3686L27.4555 37.8824H34.1087Z"
                          fill="white"
                        ></path>
                        <path
                          d="M47.5689 50.0703C47.4713 50.0703 47.3788 50.026 47.3168 49.9493C47.2545 49.8728 47.2294 49.7721 47.248 49.6746L48.6135 42.5296C48.7434 41.8501 48.7114 41.3624 48.5234 41.1563C48.4083 41.0304 48.0627 40.8191 47.0406 40.8191H44.5668L42.85 49.8013C42.8201 49.9575 42.6855 50.0703 42.529 50.0703H39.0965C38.9988 50.0703 38.9063 50.026 38.8442 49.9493C38.7821 49.8728 38.7569 49.7719 38.7755 49.6746L41.8625 33.5263C41.8923 33.3702 42.0269 33.2574 42.1834 33.2574H45.616C45.7136 33.2574 45.8061 33.3018 45.8682 33.3783C45.9303 33.455 45.9555 33.5557 45.9369 33.6532L45.1919 37.5507H47.8532C49.8806 37.5507 51.2554 37.9141 52.0561 38.6617C52.8723 39.4244 53.127 40.6439 52.8131 42.2868L51.3769 49.8013C51.347 49.9575 51.2126 50.0703 51.056 50.0703H47.5689Z"
                          fill="black"
                        ></path>
                        <path
                          d="M45.6167 32.9208H42.1841C41.8711 32.9208 41.602 33.1464 41.5423 33.4587L38.4554 49.6069C38.4181 49.8018 38.4685 50.0033 38.5927 50.1566C38.7169 50.3098 38.9019 50.3984 39.0972 50.3984H42.5298C42.8428 50.3984 43.1119 50.1729 43.1716 49.8605L44.837 41.1472H47.0414C48.0617 41.1472 48.2758 41.3688 48.2844 41.3783C48.3463 41.446 48.4277 41.7596 48.2934 42.462L46.9278 49.6069C46.8906 49.8018 46.9409 50.0033 47.0651 50.1566C47.1894 50.3098 47.3744 50.3984 47.5697 50.3984H51.0567C51.3697 50.3984 51.6389 50.1729 51.6986 49.8605L53.1347 42.346C53.4717 40.582 53.1834 39.2588 52.2781 38.4128C51.4142 37.6061 49.967 37.214 47.854 37.214H45.5891L46.2585 33.7124C46.2957 33.5175 46.2455 33.3159 46.1212 33.1628C45.997 33.0096 45.812 32.9208 45.6167 32.9208ZM45.6167 33.5856L44.7961 37.8788H47.854C49.7781 37.8788 51.1052 38.2203 51.8357 38.9023C52.5661 39.5848 52.7849 40.6906 52.493 42.2192L51.0567 49.7337H47.5697L48.9352 42.5888C49.0906 41.7761 49.0335 41.2217 48.7637 40.9261C48.4938 40.6305 47.9196 40.4824 47.0414 40.4824H44.2979L42.5298 49.7337H39.0972L42.1841 33.5856H45.6167Z"
                          fill="white"
                        ></path>
                        <path
                          d="M58.2457 46.8531C59.5604 46.8531 60.5419 46.6066 61.1629 46.1207C61.7773 45.6398 62.2017 44.8066 62.4242 43.6441C62.6315 42.5577 62.5525 41.7991 62.1893 41.3897C61.8181 40.9716 61.0154 40.7595 59.8036 40.7595H57.7026L56.5378 46.8531H58.2457ZM51.3738 54.3594C51.2763 54.3594 51.1836 54.3151 51.1216 54.2384C51.0595 54.1618 51.0342 54.061 51.0529 53.9636L54.1398 37.8154C54.1698 37.6593 54.3042 37.5465 54.4608 37.5465H61.1138C63.2048 37.5465 64.761 38.1237 65.7394 39.2624C66.7228 40.4069 67.0264 42.0068 66.642 44.0177C66.4853 44.8369 66.2162 45.5977 65.8419 46.2789C65.4672 46.9608 64.9719 47.5918 64.3696 48.1546C63.6487 48.8407 62.8327 49.3381 61.9466 49.6308C61.0745 49.9197 59.9545 50.0661 58.6177 50.0661H55.9236L55.1546 54.0904C55.1247 54.2466 54.9902 54.3594 54.8336 54.3594H51.3738Z"
                          fill="black"
                        ></path>
                        <path
                          d="M57.9708 41.0954H59.8024C61.2649 41.0954 61.7729 41.4217 61.9455 41.6162C62.232 41.939 62.286 42.6197 62.1019 43.5845C61.895 44.6649 61.5116 45.4308 60.9622 45.8609C60.3997 46.3012 59.4853 46.5243 58.2444 46.5243H56.9332L57.9708 41.0954ZM61.1125 37.2177H54.4594C54.1465 37.2177 53.8774 37.4433 53.8177 37.7556L50.7308 53.9038C50.6935 54.0987 50.7439 54.3002 50.868 54.4535C50.9922 54.6067 51.1772 54.6953 51.3725 54.6953H54.8323C55.1453 54.6953 55.4144 54.4697 55.4742 54.1574L56.1919 50.4021H58.6164C59.9875 50.4021 61.1417 50.2501 62.0467 49.9504C62.9774 49.6429 63.8339 49.1215 64.5918 48.4008C65.2186 47.8146 65.7347 47.1566 66.1259 46.4448C66.5172 45.7327 66.7984 44.9386 66.9615 44.0846C67.3663 41.9679 67.0375 40.273 65.9841 39.0472C64.9411 37.8333 63.3021 37.2177 61.1125 37.2177ZM56.14 47.1891H58.2444C59.6393 47.1891 60.6784 46.9219 61.3611 46.3876C62.044 45.8531 62.5044 44.9611 62.7437 43.7112C62.9727 42.5111 62.8685 41.6641 62.4308 41.1708C61.9928 40.6774 61.1168 40.4307 59.8024 40.4307H57.4318L56.14 47.1891ZM61.1125 37.8824C63.114 37.8824 64.5741 38.4165 65.4918 39.4846C66.4096 40.5528 66.6858 42.0437 66.3197 43.9579C66.169 44.7464 65.9141 45.4673 65.5552 46.1205C65.196 46.774 64.7268 47.3717 64.1471 47.9135C63.4562 48.5709 62.6888 49.0393 61.8442 49.3183C60.9997 49.598 59.9241 49.7373 58.6164 49.7373H55.6529L54.8323 54.0306H51.3725L54.4594 37.8824H61.1125Z"
                          fill="white"
                        ></path>
                      </g>
                      <defs>
                        <radialgradient
                          id="paint0_radial_4061_21375"
                          cx="0"
                          cy="0"
                          r="1"
                          gradientUnits="userSpaceOnUse"
                          gradientTransform="translate(32.9602 34.5549) scale(39.5626 40.2243)"
                        >
                          <stop stopColor="#AEB2D5"></stop>
                          <stop offset="0.3" stopColor="#AEB2D5"></stop>
                          <stop offset="0.75" stopColor="#484C89"></stop>
                          <stop offset="1" stopColor="#484C89"></stop>
                        </radialgradient>
                        <clippath id="clip0_4061_21375">
                          <rect
                            width="62"
                            height="34"
                            fill="white"
                            transform="translate(14 28)"
                          ></rect>
                        </clippath>
                      </defs>
                    </svg>
                  </i>
                  <h5>PHP</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#F0F4EA"
                      ></rect>
                      <path
                        d="M29.1075 44.3374C29.1075 44.0923 28.9696 43.8608 28.7488 43.7383L22.8987 40.4156C22.8021 40.3612 22.6917 40.3339 22.5814 40.3203H22.5262C22.4158 40.3203 22.3054 40.3612 22.2088 40.4156L16.3587 43.7383C16.138 43.8608 16 44.0923 16 44.3374L16.0138 53.2704C16.0138 53.393 16.0828 53.5155 16.1932 53.57C16.3035 53.6381 16.4415 53.6381 16.5381 53.57L20.015 51.6091C20.2358 51.4866 20.3738 51.2551 20.3738 51.0099V46.8294C20.3738 46.5843 20.5118 46.3528 20.7325 46.2303L22.2088 45.386C22.3192 45.3179 22.4434 45.2907 22.5676 45.2907C22.6917 45.2907 22.8159 45.3179 22.9125 45.386L24.3888 46.2303C24.6096 46.3528 24.7476 46.5843 24.7476 46.8294V51.0099C24.7476 51.2551 24.8855 51.4866 25.1063 51.6091L28.5832 53.57C28.6936 53.6381 28.8316 53.6381 28.942 53.57C29.0524 53.5155 29.1213 53.393 29.1213 53.2704L29.1075 44.3374Z"
                        fill="#333333"
                      ></path>
                      <path
                        d="M57.2269 32.0409C57.1166 31.9864 56.9786 31.9864 56.882 32.0409C56.7716 32.1089 56.7026 32.2179 56.7026 32.3404V41.1917C56.7026 41.2734 56.6612 41.3551 56.5785 41.4096C56.4957 41.4505 56.4129 41.4505 56.3301 41.4096L54.8676 40.5789C54.6468 40.4564 54.3847 40.4564 54.1639 40.5789L48.3138 43.9152C48.093 44.0378 47.9551 44.2693 47.9551 44.5144V51.1733C47.9551 51.4184 48.093 51.6499 48.3138 51.7724L54.1639 55.1087C54.3847 55.2312 54.6468 55.2312 54.8676 55.1087L60.7177 51.7724C60.9384 51.6499 61.0764 51.4184 61.0764 51.1733V34.5737C61.0764 34.315 60.9384 34.0835 60.7177 33.9609L57.2269 32.0409ZM56.6888 48.9809C56.6888 49.049 56.6612 49.1034 56.6061 49.1307L54.6054 50.2745C54.5502 50.3017 54.4813 50.3017 54.4261 50.2745L52.4254 49.1307C52.3703 49.1034 52.3427 49.0353 52.3427 48.9809V46.6931C52.3427 46.6251 52.3703 46.5706 52.4254 46.5434L54.4261 45.3995C54.4813 45.3723 54.5502 45.3723 54.6054 45.3995L56.6061 46.5434C56.6612 46.5706 56.6888 46.6387 56.6888 46.6931V48.9809Z"
                        fill="#333333"
                      ></path>
                      <path
                        d="M76.6939 46.6376C76.9146 46.5151 77.0388 46.2836 77.0388 46.0385V44.418C77.0388 44.1729 76.9008 43.9414 76.6939 43.8189L70.8852 40.4962C70.6644 40.3737 70.4023 40.3737 70.1815 40.4962L64.3314 43.8325C64.1106 43.955 63.9727 44.1865 63.9727 44.4316V51.0905C63.9727 51.3356 64.1106 51.5671 64.3314 51.6897L70.1401 54.9579C70.3609 55.0804 70.623 55.0804 70.83 54.9579L74.3483 53.0242C74.4587 52.9697 74.5277 52.8472 74.5277 52.7246C74.5277 52.6021 74.4587 52.4795 74.3483 52.425L68.4706 49.0888C68.3602 49.0207 68.2912 48.9118 68.2912 48.7892V46.7057C68.2912 46.5832 68.3602 46.4606 68.4706 46.4062L70.3057 45.3712C70.416 45.3031 70.554 45.3031 70.6644 45.3712L72.4995 46.4062C72.6098 46.4742 72.6788 46.5832 72.6788 46.7057V48.3398C72.6788 48.4624 72.7478 48.5849 72.8582 48.6394C72.9686 48.7075 73.1065 48.7075 73.2169 48.6394L76.6939 46.6376Z"
                        fill="#333333"
                      ></path>
                      <path
                        d="M70.4444 46.3232C70.4858 46.2959 70.541 46.2959 70.5824 46.3232L71.7 46.9632C71.7413 46.9904 71.7689 47.0313 71.7689 47.0857V48.3658C71.7689 48.4202 71.7413 48.4611 71.7 48.4883L70.5824 49.1283C70.541 49.1556 70.4858 49.1556 70.4444 49.1283L69.3268 48.4883C69.2854 48.4611 69.2578 48.4202 69.2578 48.3658V47.0857C69.2578 47.0313 69.2854 46.9904 69.3268 46.9632L70.4444 46.3232Z"
                        fill="#539E43"
                      ></path>
                      <path
                        d="M38.8905 40.5275C38.6698 40.4049 38.4076 40.4049 38.1869 40.5275L32.3781 43.8365C32.1574 43.959 32.0332 44.1905 32.0332 44.4357V51.0673C32.0332 51.3124 32.1712 51.5439 32.3781 51.6665L38.1869 54.9755C38.4076 55.0981 38.6698 55.0981 38.8905 54.9755L44.6992 51.6665C44.92 51.5439 45.0442 51.3124 45.0442 51.0673V44.4357C45.0442 44.1905 44.9062 43.959 44.6992 43.8365L38.8905 40.5275Z"
                        fill="url(#paint0_linear_4061_21426)"
                      ></path>
                      <defs>
                        <lineargradient
                          id="paint0_linear_4061_21426"
                          x1="40.9052"
                          y1="42.9942"
                          x2="34.6564"
                          y2="52.9423"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#41873F"></stop>
                          <stop offset="0.3288" stopColor="#418B3D"></stop>
                          <stop offset="0.6352" stopColor="#419637"></stop>
                          <stop offset="0.9319" stopColor="#3FA92D"></stop>
                          <stop offset="1" stopColor="#3FAE2A"></stop>
                        </lineargradient>
                      </defs>
                    </svg>
                  </i>
                  <h5>Node</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <span>
                    <img src="/img/python.png" alt="python" width="70" height="80"       loading="lazy"  />
                  </span>
                  <h5>Python</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#F2F6F2"
                      ></rect>
                      <g clipPath="url(#clip0_4061_21543)">
                        <path
                          d="M50.9264 24.0004L45.4994 33.4688L40.0725 24.0004H22L45.4994 65L68.9988 24.0004H50.9264Z"
                          fill="#41B883"
                        ></path>
                        <path
                          d="M50.927 24.0023L45.5 33.4706L40.0731 24.0023H31.4004L45.5 48.6016L59.5997 24.0023H50.927Z"
                          fill="#34495E"
                        ></path>
                      </g>
                      <defs>
                        <clippath id="clip0_4061_21543">
                          <rect
                            width="47"
                            height="41"
                            fill="white"
                            transform="translate(22 24)"
                          ></rect>
                        </clippath>
                      </defs>
                    </svg>
                  </i>
                  <h5>VueJS</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#FEF3F1"
                      ></rect>
                      <path
                        d="M60.2409 34.4822L46.4606 26.4806C45.5916 25.9856 44.46 25.9856 43.5841 26.4806L29.6566 34.4822C28.7597 34.9981 28.125 35.9678 28.125 37.005V52.9869C28.125 54.0241 28.7763 54.9941 29.6731 55.5128L33.3528 57.6028C35.1116 58.4691 35.7331 58.4691 36.5334 58.4691C39.1375 58.4691 40.625 56.8944 40.625 54.1478V38.3697C40.625 38.1469 40.5091 37.8153 40.2903 37.8153H38.5331C38.3106 37.8153 37.8125 38.1469 37.8125 38.3694V54.1475C37.8125 55.365 36.7112 56.5766 34.6531 55.5475L30.8509 53.3559C30.7184 53.2841 30.625 53.1394 30.625 52.9869V37.005C30.625 36.8544 30.7984 36.7031 30.9319 36.6259L44.8144 28.6381C44.9441 28.5647 45.1347 28.5647 45.2641 28.6381L58.9772 36.6241C59.1084 36.7031 59.0622 36.8497 59.0622 37.005V52.9869C59.0622 53.1394 59.1194 53.2878 58.9897 53.3613L45.2128 61.3538C45.0947 61.4247 44.9481 61.4247 44.8187 61.3538L41.2853 59.2447C41.1788 59.1828 41.0522 59.1606 40.95 59.2178C39.9669 59.775 39.7856 59.8491 38.8634 60.1688C38.6366 60.2478 38.3019 60.385 38.9916 60.7716L43.6159 63.5072C44.0588 63.7634 44.5619 63.8966 45.0681 63.8966C45.5813 63.8966 46.0837 63.7634 46.5266 63.5072L60.2406 55.5128C61.1375 54.9903 61.5625 54.0241 61.5625 52.9869V37.005C61.5625 35.9678 61.1375 35.0006 60.2409 34.4822ZM49.3469 50.4544C45.6825 50.4544 44.8753 49.4434 44.6063 47.6213C44.575 47.425 44.4084 47.1903 44.2087 47.1903H42.4178C42.1962 47.1903 42.0181 47.4591 42.0181 47.6797C42.0181 50.0128 43.2866 52.8397 49.3472 52.8397C53.7344 52.8397 56.2497 51.135 56.2497 48.1181C56.2497 45.1269 54.2288 44.3419 49.9741 43.7788C45.6734 43.2103 45.2366 42.9231 45.2366 41.9156C45.2366 41.085 45.6066 39.9772 48.7909 39.9772C51.6362 39.9772 52.685 40.5878 53.1166 42.5056C53.1534 42.6859 53.3181 42.8153 53.5041 42.8153H55.3022C55.4128 42.8153 55.5184 42.7706 55.5959 42.6916C55.6709 42.6066 55.7106 42.5 55.7006 42.3856C55.4222 39.0831 53.2281 37.5441 48.7906 37.5441C44.8434 37.5441 42.4888 39.2109 42.4888 42.005C42.4888 45.0356 44.8316 45.8731 48.6206 46.2478C53.1534 46.6922 53.5059 47.3547 53.5059 48.2463C53.5059 49.7947 52.2628 50.4544 49.3469 50.4544Z"
                        fill="#BE2025"
                      ></path>
                    </svg>
                  </i>
                  <h5>ReactJS</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#F9EBEA"
                      ></rect>
                      <path
                        d="M25 31.7069L44.2517 25L64.0217 31.5877L60.8207 56.4926L44.2517 65.465L27.9419 56.6119L25 31.7069Z"
                        fill="#E23237"
                      ></path>
                      <path
                        d="M64.0217 31.5877L44.2517 25V65.465L60.8207 56.5075L64.0217 31.5877Z"
                        fill="#B52E31"
                      ></path>
                      <path
                        d="M44.2813 29.7266L32.2852 55.8239L36.7666 55.7494L39.1749 49.8622H44.2965H44.3118H49.9364L52.5734 55.8239L56.8566 55.8984L44.2813 29.7266ZM44.3118 38.0878L48.3664 46.3746H44.4794H44.2813H40.7449L44.3118 38.0878Z"
                        fill="white"
                      ></path>
                    </svg>
                  </i>
                  <h5>Angular</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#F3EBE2"
                      ></rect>
                      <path
                        d="M33.5072 48.385C33.5072 47.25 37.8133 46.6133 39.8186 46.4586L40.0103 46.5693C39.2401 46.7096 36.1492 47.2546 36.1492 47.9658C36.1492 48.7398 40.8898 49.247 43.641 49.247C48.314 49.247 51.4907 48.5397 52.345 48.307L53.5406 49.0022C52.7218 49.4033 49.2079 50.4532 43.641 50.4532C37.4547 50.4532 33.5072 49.2432 33.5072 48.385ZM42.9359 64.3208C40.4872 64.342 37.4979 64.1396 34.9832 63.7173L34.7497 63.8507C37.2553 64.5854 40.7434 65.0288 44.5758 64.9955C52.1024 64.9303 58.2046 63.0638 58.3251 60.8175L58.2387 60.7668C57.7338 61.3823 54.4784 64.22 42.9359 64.3208ZM43.5765 62.8743C49.737 62.8205 56.6292 61.6151 56.6117 59.5886C56.608 59.2209 56.3691 58.9692 56.1614 58.8176L56.0598 58.876C55.4904 60.4453 50.6779 61.6052 43.5666 61.6667C38.9785 61.7069 32.6223 60.6076 32.611 59.3377C32.6003 58.064 35.6222 57.3643 35.6222 57.3643L35.4084 57.2423C33.3835 57.5213 29.652 58.4909 29.6641 59.8912C29.6817 61.9152 38.2576 62.9205 43.5765 62.8743ZM57.4548 48.9271C57.3305 51.3038 55.1349 52.7837 52.9402 54.0339L53.1388 54.1491C55.4807 53.4896 59.6594 51.5715 59.3137 48.6223C59.1417 47.1523 57.7975 46.1016 56.0454 46.1016C55.4996 46.1016 55.0144 46.1978 54.6209 46.3176L54.6194 46.3214L54.536 46.5306C56.1038 46.2236 57.5359 47.3684 57.4548 48.9271ZM39.3592 55.989C38.6442 56.1315 37.0863 56.4894 37.0863 57.2467C37.0863 58.2959 40.419 59.1003 43.6372 59.1003C48.0655 59.1003 49.8797 57.9609 49.9615 57.9017L48.12 56.8365C47.3369 57.023 46.0177 57.3156 43.6418 57.3156C40.9907 57.3156 39.2629 56.8623 39.2629 56.3649C39.2629 56.2596 39.3289 56.1338 39.4516 56.0428L39.3592 55.989ZM50.2374 52.4516C49.2192 52.7397 46.9252 53.2097 43.6448 53.2097C40.4258 53.2097 37.7959 52.6593 37.7875 52.0104C37.7814 51.5782 38.3037 51.3902 38.3037 51.3902L38.2112 51.3364C36.6692 51.6086 35.2378 52.0301 35.2455 52.6608C35.2599 53.8048 39.6357 54.6638 43.6387 54.6638C47.0419 54.6638 50.3102 54.093 51.7847 53.3447L50.2374 52.4516Z"
                        fill="#427595"
                      ></path>
                      <path
                        d="M49.3595 26.9325C49.3595 33.2409 40.7146 35.6546 40.7146 40.1397C40.7146 43.2883 42.8025 45.2624 43.9579 46.511L43.8638 46.5656C42.4052 45.6528 38.5684 43.3602 38.5684 39.5734C38.5684 34.2567 48.4983 31.7162 48.4983 25.6778C48.4983 24.9348 48.3883 24.3648 48.3111 24.0577L48.4112 24C48.7257 24.395 49.3595 25.3836 49.3595 26.9325ZM52.2025 32.519L52.0987 32.4599C50.2178 33.0899 44.4257 35.3764 44.4257 39.6386C44.4257 42.0486 46.7797 43.3845 46.7797 45.6445C46.7797 46.4511 46.324 47.207 45.954 47.6588L46.1397 47.7664C47.12 47.1296 48.8546 45.7506 48.8546 43.9705C48.8546 42.4627 46.7682 40.6507 46.7682 38.7129C46.7683 35.6592 50.7939 33.2635 52.2025 32.519Z"
                        fill="#DE8E2F"
                      ></path>
                    </svg>
                  </i>
                  <h5>Java</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#EBF5FA"
                      ></rect>
                      <path
                        d="M49.324 25L29 45.392L35.2907 51.7038L61.9055 25H49.324Z"
                        fill="#47C5FB"
                      ></path>
                      <path
                        d="M49.1828 43.8047L38.3008 54.7232L44.6151 61.1533L50.8942 54.8532L61.906 43.8047H49.1828Z"
                        fill="#47C5FB"
                      ></path>
                      <path
                        d="M44.6152 61.1516L49.3953 65.9477H61.906L50.8942 54.8516L44.6152 61.1516Z"
                        fill="#00569E"
                      ></path>
                      <path
                        d="M38.2285 54.7962L44.5193 48.4844L50.8926 54.8554L44.6137 61.1554L38.2285 54.7962Z"
                        fill="#00B5F8"
                      ></path>
                      <path
                        d="M44.6152 61.15L49.8437 59.4092L50.363 55.3828L44.6152 61.15Z"
                        fill="url(#paint0_linear_4061_21406)"
                        fillOpacity="0.8"
                      ></path>
                      <defs>
                        <lineargradient
                          id="paint0_linear_4061_21406"
                          x1="44.8424"
                          y1="56.9395"
                          x2="48.9808"
                          y2="58.4259"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop></stop>
                          <stop offset="1" stopOpacity="0"></stop>
                        </lineargradient>
                      </defs>
                    </svg>
                  </i>
                  <h5>Flutter</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <i>
                    <svg
                      width="90"
                      height="90"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="90"
                        height="90"
                        rx="12"
                        fill="#F6F8F9"
                      ></rect>
                      <path
                        d="M22 45.305C22 41.9061 25.3184 38.7331 30.5503 36.9446C29.5055 31.6842 30.363 27.4444 33.2272 25.7923C36.1712 24.0943 40.5572 25.2697 44.72 28.909C48.7778 25.4166 52.879 24.0421 55.7405 25.6989C58.6817 27.4019 59.5763 31.9293 58.5027 37.3539C63.9519 39.1558 67 41.8614 67 45.305C67 48.6251 63.6754 51.4974 58.5142 53.2745C59.67 58.9233 58.6906 63.0603 55.7079 64.7806C52.8322 66.4391 48.6835 64.9935 44.566 61.4096C40.2824 65.2137 36.1746 66.3751 33.1948 64.6497C30.3219 62.9865 29.5021 58.6696 30.5503 53.3118C25.4951 51.549 22 48.6118 22 45.305Z"
                        fill="#F6F8F9"
                      ></path>
                      <path
                        d="M57.888 51.9762C57.4731 52.1188 57.0431 52.2537 56.6004 52.3813C56.6732 52.6778 56.7399 52.9704 56.7993 53.2581C57.774 57.9817 57.1367 61.7871 54.9605 63.04C52.8738 64.2414 49.4611 62.9888 46.0145 59.9942C45.6831 59.7063 45.3507 59.4014 45.0185 59.0819C44.7972 59.2933 44.5761 59.4976 44.3557 59.693C40.7436 62.895 37.1229 64.2443 34.9488 62.9878C32.8641 61.7829 32.2468 58.2055 33.1241 53.7289C33.2089 53.2965 33.3079 52.8549 33.4199 52.4059C32.9075 52.2607 32.4128 52.1059 31.9395 51.9412C27.7046 50.4672 25 48.157 25 45.7607C25 43.2858 27.9034 40.8035 32.3143 39.2983C32.6624 39.1795 33.0236 39.0672 33.3958 38.9606C33.275 38.475 33.1699 37.9992 33.0817 37.5351C32.2451 33.1362 32.8984 29.6432 34.9776 28.446C37.1252 27.2096 40.7295 28.4805 44.2391 31.5433C44.5165 31.7854 44.7949 32.0421 45.0738 32.3112C45.4352 31.9637 45.7962 31.6348 46.1551 31.3263C49.5546 28.4057 52.9122 27.2264 54.9894 28.427C57.1349 29.667 57.8321 33.4192 56.9269 37.9844C56.8578 38.3331 56.7773 38.6893 56.687 39.0518C56.9401 39.1265 57.1886 39.2036 57.4309 39.2838C62.0165 40.8006 65 43.2528 65 45.7607C65 48.1656 62.2082 50.4914 57.888 51.9762Z"
                        fill="#53C1DE"
                      ></path>
                      <path
                        d="M56.5292 40.3421C56.308 40.2688 56.081 40.1979 55.8497 40.1292C55.3377 41.7514 54.6467 43.4762 53.801 45.2583C54.608 46.9979 55.2723 48.7008 55.77 50.3123C56.1838 50.1925 56.5855 50.0661 56.9726 49.9327C60.7164 48.643 63 46.7361 63 45.2667C63 43.7016 60.5337 41.6699 56.5292 40.3421ZM54.8676 37.0471C55.2725 35.0006 55.3303 33.1502 55.0621 31.7037C54.8212 30.404 54.3366 29.5374 53.7375 29.1903C52.4625 28.4518 49.736 29.4118 46.7955 31.944C46.4584 32.2343 46.1189 32.5442 45.7782 32.8723C46.9182 34.1199 48.0575 35.5704 49.1694 37.1812C51.1252 37.3549 52.973 37.6388 54.6486 38.0265C54.7311 37.6933 54.8045 37.3666 54.8676 37.0471ZM38.0643 29.318C36.8187 28.8777 35.8265 28.8651 35.2268 29.2112C33.9507 29.9477 33.4202 32.791 34.1438 36.6049C34.2267 37.0417 34.3254 37.4904 34.4391 37.949C36.0964 37.5823 37.9306 37.3184 39.891 37.1593C41.0105 35.5831 42.1827 34.1342 43.364 32.8656C43.1059 32.6162 42.8488 32.3788 42.5932 32.1552C41.0235 30.7821 39.4506 29.8079 38.0643 29.318ZM32.2285 40.3516C30.2558 41.0264 28.6267 41.9033 27.51 42.8603C26.5066 43.7202 26 44.574 26 45.2667C26 46.741 28.1963 48.6213 31.8593 49.8994C32.3038 50.0545 32.7691 50.2006 33.2519 50.3379C33.7581 48.6899 34.4222 46.967 35.2237 45.2247C34.4119 43.4565 33.7383 41.706 33.2271 40.0387C32.8829 40.1378 32.5494 40.242 32.2285 40.3516ZM34.1847 53.6771C33.4244 57.5656 33.9294 60.4989 35.2 61.235C36.5535 62.0191 39.5464 60.9011 42.7008 58.0981C42.9024 57.919 43.1049 57.7315 43.3079 57.5375C42.1324 56.2744 40.9709 54.8364 39.8615 53.2694C37.9587 53.093 36.1374 52.8095 34.4629 52.4298C34.3576 52.8536 34.2643 53.27 34.1847 53.6771ZM51.6359 49.3648C51.2355 50.0568 50.8246 50.7324 50.4056 51.3896C51.6964 51.2263 52.9331 51.0095 54.0946 50.7442C53.7459 49.6259 53.3113 48.4567 52.7997 47.258C52.4327 47.9553 52.0446 48.6582 51.6359 49.3648ZM44.5193 56.3014C45.3165 55.4371 46.1148 54.4722 46.9001 53.4252C46.1088 53.4626 45.3077 53.4821 44.5 53.4821C43.7 53.4821 42.9048 53.4631 42.1185 53.4263C42.9045 54.4636 43.7097 55.4272 44.5193 56.3014ZM37.3572 49.3529C36.9574 48.659 36.5764 47.9598 36.2152 47.2593C35.7119 48.4538 35.2813 49.6284 34.9296 50.7625C36.0839 51.021 37.3148 51.2324 38.5974 51.3926C38.1726 50.7294 37.7582 50.0488 37.3572 49.353V49.3529ZM38.6344 39.0175C37.3092 39.1655 36.0598 39.3659 34.9058 39.6173C35.2631 40.7717 35.7032 41.9714 36.2171 43.1916C36.5793 42.4916 36.9617 41.7921 37.3641 41.0967H37.3641C37.774 40.3882 38.1986 39.6943 38.6344 39.0175ZM44.5672 34.1101C43.748 34.9946 42.931 35.9729 42.133 37.0253C42.9076 36.9949 43.6974 36.9793 44.5 36.9793C45.3246 36.9793 46.1398 36.9979 46.9422 37.0336C46.1544 35.9623 45.3589 34.9825 44.5672 34.1101ZM52.8162 43.2538C53.3569 42.0204 53.8128 40.827 54.1747 39.6922C53.0017 39.4245 51.7352 39.2088 50.4008 39.0485C50.8208 39.7145 51.2354 40.4017 51.6428 41.1086C52.0549 41.8238 52.4462 42.54 52.8162 43.2538ZM50.1457 41.9727C49.5133 40.8753 48.864 39.8278 48.2049 38.839C47.0044 38.7531 45.7641 38.7089 44.5 38.7089C43.241 38.7089 42.0164 38.748 40.8371 38.8246C40.1514 39.8264 39.4881 40.877 38.8597 41.9632H38.8598C38.2331 43.0465 37.6563 44.1389 37.1336 45.2252C37.6562 46.3141 38.2315 47.4077 38.8546 48.489L38.8544 48.4888C39.4792 49.573 40.1368 50.6185 40.8161 51.614C42.0193 51.7051 43.2531 51.7526 44.5 51.7526H44.5C45.7525 51.7526 46.9879 51.7047 48.1907 51.6129C48.8597 50.6247 49.5128 49.5825 50.14 48.4982C50.7744 47.4017 51.3571 46.3153 51.8841 45.2498C51.3587 44.166 50.7773 43.0687 50.1457 41.9727ZM53.711 61.2864C55.0657 60.5046 55.5926 57.3515 54.7414 53.2168C54.6871 52.9529 54.6259 52.6842 54.5595 52.4119C52.8811 52.7994 51.0585 53.0878 49.1502 53.267C48.0386 54.8512 46.8866 56.2914 45.7303 57.5383C46.0412 57.8375 46.3516 58.1229 46.6608 58.3922C49.6475 60.9934 52.4391 62.0204 53.711 61.2864Z"
                        fill="#F6F8F9"
                      ></path>
                      <path
                        d="M44.5 48.6875C46.433 48.6875 48 47.141 48 45.2332C48 43.3254 46.433 41.7788 44.5 41.7788C42.567 41.7788 41 43.3254 41 45.2332C41 47.141 42.567 48.6875 44.5 48.6875Z"
                        fill="#53C1DE"
                      ></path>
                    </svg>
                  </i>
                  <h5>React Native</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <span>
                    <img src="/img/kotlinlang-icon.svg" width="70" height="80" alt="Kotlin" />
                  </span>
                  <h5>Kotlin</h5>
                </div>
              </li>
              <li>
                <div className="techstacks-module--techstacks_info--517f9">
                  <span>
                    <img src="/img/swift-icon.svg" width="70" height="80" alt="Kotlin"   />
                  </span>
                  <h5>Swift</h5>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* <section className="blog-module--blog--4620a undefined">
          <div className="container">
            <div className="blog-module--blog_wrap--8a13d">
              <div className="blog-module--mix_heading--99150">
                <div className="blog-module--viewLink--193ed">
                  <span data-aos="fade-up" data-aos-delay="50">_Blogs</span
                  ><a href="/blogs/"
                    ><span
                    className="linkButtonMore-module--btn_more--38bca undefined"
                      >View all<i
                        ><svg
                          width="25"
                          height="12"
                          viewBox="0 0 25 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M24.5492 5.33639C24.549 5.33611 24.5487 5.33578 24.5484 5.3355L19.6498 0.460497C19.2828 0.0952938 18.6892 0.0966529 18.3239 0.463684C17.9587 0.830668 17.9601 1.42425 18.3271 1.7895L21.616 5.0625H1.76172C1.24394 5.0625 0.824219 5.48221 0.824219 6C0.824219 6.51778 1.24394 6.9375 1.76172 6.9375H21.616L18.3271 10.2105C17.9601 10.5757 17.9587 11.1693 18.324 11.5363C18.6893 11.9034 19.2829 11.9047 19.6498 11.5395L24.5485 6.6645C24.5487 6.66421 24.549 6.66389 24.5493 6.66361C24.9165 6.29714 24.9153 5.70164 24.5492 5.33639Z"
                            fill="black"
                          ></path></svg></i></span
                  ></a>
                </div>
                <h2 data-aos="fade-up" data-aos-delay="100">Alphai Solution insights</h2>
                <p data-aos="fade-up" data-aos-delay="150">
                  Explore the latest insights to keep up with the most latest
                  developments and challenges in IT, Cloud, &amp; Software
                  industry
                </p>
              </div>
            </div>
            <ul
              className="blog-module--blog_listing--13ba0"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <li>
                <a
                  href="/blogs/why-hire-indias-top-mobile-app-development-company/"
                >
                  <picture>
                    <source
                      srcSet="
                        https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2022/12/Why-Hire-Indias-Top-Mobile-App.webp
                      "
                      media="(min-width: 150px)"
                      type="image/webp" />
                    <img
                      src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2022/12/Why-Hire-Indias-Top-Mobile-App.jpg"
                      alt="Mobile App Development"
                      loading="lazy"
                      width="100%"
                      height="100%"
                  /></picture>
                  <figcaption>
                    Why Hire India’s Top Mobile App Development Company?
                  </figcaption>
                </a>
                <ul className="blog-module--blog_dt_tm--29bb3">
                  <li>12 Dec, 2022</li>
                  <li>
                    <i
                      ><svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.94 11.86L11.84 10.96L8.66 7.76V3.74H7.46V8.24L10.94 11.86ZM8 16C6.90667 16 5.87333 15.79 4.9 15.37C3.92667 14.95 3.07667 14.3767 2.35 13.65C1.62333 12.9233 1.05 12.0733 0.63 11.1C0.21 10.1267 0 9.09333 0 8C0 6.90667 0.21 5.87333 0.63 4.9C1.05 3.92667 1.62333 3.07667 2.35 2.35C3.07667 1.62333 3.92667 1.05 4.9 0.63C5.87333 0.21 6.90667 0 8 0C9.09333 0 10.1267 0.21 11.1 0.63C12.0733 1.05 12.9233 1.62333 13.65 2.35C14.3767 3.07667 14.95 3.92667 15.37 4.9C15.79 5.87333 16 6.90667 16 8C16 9.09333 15.79 10.1267 15.37 11.1C14.95 12.0733 14.3767 12.9233 13.65 13.65C12.9233 14.3767 12.0733 14.95 11.1 15.37C10.1267 15.79 9.09333 16 8 16ZM8 14.8C9.86667 14.8 11.4667 14.1333 12.8 12.8C14.1333 11.4667 14.8 9.86667 14.8 8C14.8 6.13333 14.1333 4.53333 12.8 3.2C11.4667 1.86667 9.86667 1.2 8 1.2C6.13333 1.2 4.53333 1.86667 3.2 3.2C1.86667 4.53333 1.2 6.13333 1.2 8C1.2 9.86667 1.86667 11.4667 3.2 12.8C4.53333 14.1333 6.13333 14.8 8 14.8Z"
                          fill="#4D4D4D"
                        ></path></svg></i
                    >6
                    min
                  </li>
                </ul>
              </li>
              <li>
                <a
                  href="/blogs/lean-agile-and-scrum-which-approach-will-be-the-best-for-your-app-development/"
                >
                  <picture>
                    <source
                      srcSet="
                        https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2022/07/Lean-Agile-and-Scrum.webp
                      "
                      media="(min-width: 150px)"
                      type="image/webp" />
                    <img
                      src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2022/07/Lean-Agile-and-Scrum.jpg"
                      alt="app development"
                      loading="lazy"
                      width="100%"
                      height="100%"
                  /></picture>
                  <figcaption>
                    Lean, Alphai Solution and Scrum – Which approach will be the best for
                    your app development?
                  </figcaption>
                </a>
                <ul className="blog-module--blog_dt_tm--29bb3">
                  <li>05 Jul, 2022</li>
                  <li>
                    <i
                      ><svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.94 11.86L11.84 10.96L8.66 7.76V3.74H7.46V8.24L10.94 11.86ZM8 16C6.90667 16 5.87333 15.79 4.9 15.37C3.92667 14.95 3.07667 14.3767 2.35 13.65C1.62333 12.9233 1.05 12.0733 0.63 11.1C0.21 10.1267 0 9.09333 0 8C0 6.90667 0.21 5.87333 0.63 4.9C1.05 3.92667 1.62333 3.07667 2.35 2.35C3.07667 1.62333 3.92667 1.05 4.9 0.63C5.87333 0.21 6.90667 0 8 0C9.09333 0 10.1267 0.21 11.1 0.63C12.0733 1.05 12.9233 1.62333 13.65 2.35C14.3767 3.07667 14.95 3.92667 15.37 4.9C15.79 5.87333 16 6.90667 16 8C16 9.09333 15.79 10.1267 15.37 11.1C14.95 12.0733 14.3767 12.9233 13.65 13.65C12.9233 14.3767 12.0733 14.95 11.1 15.37C10.1267 15.79 9.09333 16 8 16ZM8 14.8C9.86667 14.8 11.4667 14.1333 12.8 12.8C14.1333 11.4667 14.8 9.86667 14.8 8C14.8 6.13333 14.1333 4.53333 12.8 3.2C11.4667 1.86667 9.86667 1.2 8 1.2C6.13333 1.2 4.53333 1.86667 3.2 3.2C1.86667 4.53333 1.2 6.13333 1.2 8C1.2 9.86667 1.86667 11.4667 3.2 12.8C4.53333 14.1333 6.13333 14.8 8 14.8Z"
                          fill="#4D4D4D"
                        ></path></svg></i
                    >5
                    min
                  </li>
                </ul>
              </li>
              <li>
                <a
                  href="/blogs/how-flutter-app-development-can-be-a-perfect-fit-for-your-project/"
                >
                  <picture>
                    <source
                      srcSet="
                        https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2022/06/Flutter-app-development.webp
                      "
                      media="(min-width: 150px)"
                      type="image/webp" />
                    <img
                      src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2022/06/Flutter-app-development.jpg"
                      alt="Flutter app development"
                      loading="lazy"
                      width="100%"
                      height="100%"
                  /></picture>
                  <figcaption>
                    How Flutter app development can be a perfect fit for your
                    project?
                  </figcaption>
                </a>
                <ul className="blog-module--blog_dt_tm--29bb3">
                  <li>08 Jun, 2022</li>
                  <li>
                    <i
                      ><svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.94 11.86L11.84 10.96L8.66 7.76V3.74H7.46V8.24L10.94 11.86ZM8 16C6.90667 16 5.87333 15.79 4.9 15.37C3.92667 14.95 3.07667 14.3767 2.35 13.65C1.62333 12.9233 1.05 12.0733 0.63 11.1C0.21 10.1267 0 9.09333 0 8C0 6.90667 0.21 5.87333 0.63 4.9C1.05 3.92667 1.62333 3.07667 2.35 2.35C3.07667 1.62333 3.92667 1.05 4.9 0.63C5.87333 0.21 6.90667 0 8 0C9.09333 0 10.1267 0.21 11.1 0.63C12.0733 1.05 12.9233 1.62333 13.65 2.35C14.3767 3.07667 14.95 3.92667 15.37 4.9C15.79 5.87333 16 6.90667 16 8C16 9.09333 15.79 10.1267 15.37 11.1C14.95 12.0733 14.3767 12.9233 13.65 13.65C12.9233 14.3767 12.0733 14.95 11.1 15.37C10.1267 15.79 9.09333 16 8 16ZM8 14.8C9.86667 14.8 11.4667 14.1333 12.8 12.8C14.1333 11.4667 14.8 9.86667 14.8 8C14.8 6.13333 14.1333 4.53333 12.8 3.2C11.4667 1.86667 9.86667 1.2 8 1.2C6.13333 1.2 4.53333 1.86667 3.2 3.2C1.86667 4.53333 1.2 6.13333 1.2 8C1.2 9.86667 1.86667 11.4667 3.2 12.8C4.53333 14.1333 6.13333 14.8 8 14.8Z"
                          fill="#4D4D4D"
                        ></path></svg></i
                    >7
                   min
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </section> */}
      <WriteToUs />
      {/* <section className="ourAlliance--module--client_partner--976ee undefined">
          <div className="container">
            <div className="ourAlliance--module--client_partner_wrap--d65c4">
              <div className="ourAlliance--module--mix_heading--b3bb3">
                <span data-aos="fade-up" data-aos-delay="50">_Awards</span>
                <h2>Our recognitions &amp; awards</h2>
                <p>Excellence rewarded, recognitions earned</p>
              </div>
              <div className="swiper-slider client-logo-slider">
                <div className="swiper">
                  <div className="swiper-wrapper">
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/Top-Web-Development-Companies-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/Top-Web-Development-Companies-1.png"
                            alt="Top Web Development Companies"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/topfirms-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/topfirms-1.png"
                            alt="Top Firms"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/topapp-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/topapp-1.png"
                            alt="Top App Developers"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/techreviewer-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/techreviewer-1.png"
                            alt="Techreviewer"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/09/aws.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/09/aws.png"
                            alt="aws"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/Mobile-App-Development-Companies-2.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/Mobile-App-Development-Companies-2.png"
                            alt="SoftwareWorld"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/Magento-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/Magento-1.png"
                            alt="Magento Certified Developer"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/iso-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/iso-1.png"
                            alt="ISO"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/GoodFirms2-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/GoodFirms2-1.png"
                            alt="GoodFirms"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/GoodFirms-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/GoodFirms-1.png"
                            alt="GoodFirms - Top Mobile App Development Company"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/DFW-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/DFW-1.png"
                            alt="DFW"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/designrush-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/designrush-1.png"
                            alt="DesignRush"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/Clutch1-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/Clutch1-1.png"
                            alt="Clutch"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/Clutch-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/Clutch-1.png"
                            alt="Clutch - Top Flutter Developers"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/azure-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/azure-1.png"
                            alt="Microsoft Azure"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/aws1-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/aws1-1.png"
                            alt="Google Cloud"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/aws-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/aws-1.png"
                            alt="AWS"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                    <div className="swiper-slide">
                      <div className="ourAlliance--module--client_logo_wrap--b9784">
                        <picture>
                          <source
                            srcSet="
                              https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/app-development-companies-1.webp
                            "
                            media="(min-width: 150px)"
                            type="image/webp" />
                          <img
                            src="https://d3gseh8bdqsug8.cloudfront.net/wp-content/uploads/2023/04/app-development-companies-1.png"
                            alt="App Development Companies"
                            loading="lazy"
                            width="100%"
                            height="100%"
                        /></picture>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
      {/* <SwiperComponent/> */}
    </>
  );
};
export default Home;
